// src/components/AdmissionPage.jsx
// Mobile View Optimized - Multi-Color Palette Theme
// Colors: #2196F3, #90CAF9, #0D47A1, #2196F3, #2196F3, #0D47A1, #90CAF9, #0D47A1
// With Carousel Navigation - 3 cards visible at a time with left/right arrows

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSchoolName } from "./schoolNameStore";
import { ArrowRight } from "lucide-react";
const CLASS_OPTIONS = ["LKG", "UKG", "Class 1", "Class 2", "Class 3", "Class 4", "Class 5", "Class 6", "Class 7", "Class 8", "Class 9", "Class 10", "Class 11", "Class 12"];
const SECTIONS = ["A", "B", "C"];
const HIGH_SCHOOL_CLASSES = ["Class 11", "Class 12"];
const HS_GROUPS = [{
  value: "Bio & Maths",
  label: "Bio & Maths",
  icon: "fa-dna",
  sub: "Physics · Chemistry · Biology · Maths"
}, {
  value: "Computer Science",
  label: "Computer Science",
  icon: "fa-laptop-code",
  sub: "Physics · Chemistry · Computer Science"
}, {
  value: "Arts & Science",
  label: "Arts & Science",
  icon: "fa-palette",
  sub: "History · Economics · Civics · Geography"
}, {
  value: "Commerce",
  label: "Commerce",
  icon: "fa-chart-line",
  sub: "Commerce · Accountancy · Economics"
}];
const DOCUMENTS = ["Birth Certificate", "Transfer Certificate (TC)", "Aadhar Card (Student)", "Aadhar Card (Parent)", "Passport Size Photos (4 nos)", "Community Certificate", "Previous Year Mark Sheet", "Conduct Certificate", "Medical Fitness Certificate"];
const STATUS_CONFIG = {
  Enquiry: {
    bg: "#FFFFFF",
    color: "#0D47A1",
    dot: "#0D47A1"
  },
  "Docs Pending": {
    bg: "#FFFFFF",
    color: "#0D47A1",
    dot: "#0D47A1"
  },
  Interview: {
    bg: "#FFFFFF",
    color: "#0D47A1",
    dot: "#0D47A1"
  },
  Admitted: {
    bg: "#0D47A1",
    color: "#FFFFFF",
    dot: "#2196F3"
  },
  "Not Admitted": {
    bg: "#FFFFFF",
    color: "#0D47A1",
    dot: "#0D47A1"
  }
};
const RELIGIONS = ["Hindu", "Christian", "Muslim", "Others"];
const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
const NATIONALITIES = ["Indian", "Others"];
const emptyForm = {
  studentName: "",
  dob: "",
  gender: "",
  religion: "",
  bloodGroup: "",
  nationality: "Indian",
  motherTongue: "",
  aadhaar: "",
  applyingClass: "",
  section: "",
  medium: "",
  group: "",
  groupCategory: "",
  fatherName: "",
  fatherOccupation: "",
  fatherMobile: "",
  fatherAadhaar: "",
  motherName: "",
  motherOccupation: "",
  motherMobile: "",
  address: "",
  city: "",
  pincode: "",
  prevSchool: "",
  prevClass: "",
  prevBoard: "",
  tcNumber: "",
  documents: [],
  status: "Enquiry",
  enquiryDate: new Date().toISOString().slice(0, 10),
  remarks: ""
};
function initials(name) {
  if (!name) return "?";
  return name.split(" ").slice(0, 2).map(w => w[0]).join("").toUpperCase();
}
const AVATAR_PALETTES = [{
  from: "#0D47A1",
  to: "#0D47A1",
  text: "#FFFFFF"
}, {
  from: "#2196F3",
  to: "#2196F3",
  text: "#FFFFFF"
}, {
  from: "#2196F3",
  to: "#2196F3",
  text: "#0D47A1"
}, {
  from: "#0D47A1",
  to: "#0D47A1",
  text: "#FFFFFF"
}, {
  from: "#2196F3",
  to: "#2196F3",
  text: "#FFFFFF"
}, {
  from: "#90CAF9",
  to: "#90CAF9",
  text: "#0D47A1"
}];
function Avatar({
  name,
  idx,
  size = 40
}) {
  const p = AVATAR_PALETTES[(idx || 0) % AVATAR_PALETTES.length];
  return <div style={{
    width: size,
    height: size,
    borderRadius: size * 0.3,
    background: `linear-gradient(135deg, ${p.from}, ${p.to})`,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: size * 0.35,
    fontWeight: 700,
    color: p.text,
    flexShrink: 0,
    letterSpacing: "-0.5px",
    boxShadow: `0 4px 12px ${p.from}40`
  }}>
      {initials(name)}
    </div>;
}
function StatusBadge({
  status
}) {
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG["Enquiry"];
  return <span style={{
    background: cfg.bg,
    color: cfg.color,
    padding: "4px 12px",
    borderRadius: 24,
    fontSize: 11,
    fontWeight: 600,
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    border: cfg.bg === "#FFFFFF" ? "1px solid #0D47A1" : "none"
  }}>
      <span style={{
      width: 6,
      height: 6,
      borderRadius: "50%",
      background: cfg.dot,
      display: "inline-block"
    }} />
      {status}
    </span>;
}
const inputBase = {
  width: "100%",
  background: "#FFFFFF",
  borderRadius: 12,
  padding: "10px 14px",
  fontSize: 13,
  color: "#0D47A1",
  fontFamily: "'Inter', sans-serif",
  outline: "none",
  transition: "all 0.2s ease",
  boxSizing: "border-box",
  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
  border: "1px solid #90CAF9"
};
function Inp({
  value,
  onChange,
  ...props
}) {
  const [f, setF] = useState(false);
  return <input value={value} onChange={onChange} {...props} style={{
    ...inputBase,
    borderColor: f ? "#0D47A1" : "#90CAF9",
    boxShadow: f ? "0 0 0 2px rgba(13,71,161,0.1)" : "0 1px 3px rgba(0,0,0,0.05)"
  }} onFocus={() => setF(true)} onBlur={() => setF(false)} />;
}
function Sel({
  value,
  onChange,
  children,
  style: extra,
  ...props
}) {
  const [f, setF] = useState(false);
  return <select value={value} onChange={onChange} {...props} style={{
    ...inputBase,
    borderColor: f ? "#0D47A1" : "#90CAF9",
    boxShadow: f ? "0 0 0 2px rgba(13,71,161,0.1)" : "0 1px 3px rgba(0,0,0,0.05)",
    cursor: "pointer",
    ...extra
  }} onFocus={() => setF(true)} onBlur={() => setF(false)}>
      {children}
    </select>;
}
function FLabel({
  label,
  required,
  children,
  err
}) {
  return <div style={{
    marginBottom: 16
  }}>
      <label style={{
      fontSize: 11,
      color: "#0D47A1",
      fontWeight: 600,
      display: "block",
      marginBottom: 6,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      fontFamily: "'Inter', sans-serif"
    }}>
        {label}{required && <span style={{
        color: "#0D47A1"
      }}> *</span>}
      </label>
      {children}
      {err && <div style={{
      fontSize: 10,
      color: "#0D47A1",
      marginTop: 4,
      fontFamily: "'Inter', sans-serif"
    }}>{err}</div>}
    </div>;
}
function SecHead({
  icon,
  title
}) {
  return <div style={{
    display: "flex",
    alignItems: "center",
    gap: 12,
    margin: "28px 0 16px"
  }}>
      <div style={{
      width: 4,
      height: 20,
      background: "#2196F3",
      borderRadius: 2
    }} />
      <span style={{
      fontSize: 11,
      fontWeight: 700,
      color: "#0D47A1",
      textTransform: "uppercase",
      letterSpacing: "1px",
      fontFamily: "'Inter', sans-serif"
    }}>
        <i className={`fas ${icon}`} style={{
        marginRight: 8
      }}></i> {title}
      </span>
      <div style={{
      flex: 1,
      height: 1,
      background: "#2196F3"
    }} />
    </div>;
}
function DRow({
  label,
  value
}) {
  if (!value) return null;
  return <div style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    padding: "10px 0",
    gap: 12,
    borderBottom: "1px solid #E3F2FD"
  }}>
      <span style={{
      fontSize: 11,
      color: "#0D47A1",
      flexShrink: 0,
      fontWeight: 500
    }}>{label}</span>
      <span style={{
      fontSize: 12,
      fontWeight: 600,
      color: "#0D47A1",
      textAlign: "right"
    }}>{value}</span>
    </div>;
}
function ConfirmDialog({
  message,
  onConfirm,
  onCancel
}) {
  return <div style={{
    position: "fixed",
    inset: 0,
    background: "rgba(13,71,161,0.5)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(8px)"
  }}>
      <div style={{
      background: "#FFFFFF",
      borderRadius: 24,
      width: "min(400px, 90%)",
      padding: 32,
      textAlign: "center",
      boxShadow: "0 40px 80px rgba(0,0,0,0.1)"
    }}>
        <div style={{
        width: 56,
        height: 56,
        borderRadius: 20,
        background: "#2196F3",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 20px",
        fontSize: 24
      }}>
          <i className="fas fa-exclamation-triangle" style={{
          color: "#0D47A1"
        }}></i>
        </div>
        <div style={{
        fontSize: 14,
        color: "#0D47A1",
        marginBottom: 28,
        lineHeight: 1.6
      }}>{message}</div>
        <div style={{
        display: "flex",
        gap: 12
      }}>
          <button onClick={onCancel} style={{
          flex: 1,
          background: "#E3F2FD",
          color: "#0D47A1",
          border: "none",
          padding: 12,
          borderRadius: 12,
          fontSize: 13,
          fontWeight: 600,
          cursor: "pointer"
        }}>Cancel</button>
          <button onClick={onConfirm} style={{
          flex: 1,
          background: "#0D47A1",
          color: "#FFFFFF",
          border: "none",
          padding: 12,
          borderRadius: 12,
          fontSize: 13,
          fontWeight: 600,
          cursor: "pointer"
        }}>Delete</button>
        </div>
      </div>
    </div>;
}
function CredentialsModal({
  student,
  onClose,
  onCredentialsUpdate
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [existingCreds, setExistingCreds] = useState(null);
  const [fetching, setFetching] = useState(true);
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);
  useEffect(() => {
    fetchExistingCredentials();
  }, [student]);
  const fetchExistingCredentials = async () => {
    try {
      const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/auth/credentials/${student._id}`);
      if (r.ok) {
        const d = await r.json();
        setExistingCreds(d);
        setUsername(d.username);
        setPassword('');
      }
    } catch {} finally {
      setFetching(false);
    }
  };
  const generateUsername = () => {
    const name = student.studentName.toLowerCase().replace(/\s/g, '');
    setUsername(`${name}_${Math.floor(Math.random() * 1000)}`);
  };
  const generatePassword = () => {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    setPassword(Array.from({
      length: 8
    }, () => chars[Math.floor(Math.random() * chars.length)]).join(''));
  };
  const handleSubmit = async () => {
    if (!username.trim() || !password.trim()) {
      alert('Please enter username and password');
      return;
    }
    setLoading(true);
    try {
      const r = await fetch('https://schoolcrm-fzcv.onrender.com/api/auth/credentials', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          studentId: student._id,
          studentName: student.studentName,
          parentName: student.fatherName,
          className: `${student.applyingClass}-${student.section}`,
          username: username.trim(),
          password: password.trim()
        })
      });
      if (!r.ok) {
        const e = await r.json();
        throw new Error(e.message || 'Failed');
      }
      const saved = await r.json();
      alert(existingCreds ? 'Updated!' : 'Generated!');
      onCredentialsUpdate(saved);
      onClose();
    } catch (err) {
      alert(err.message);
    } finally {
      setLoading(false);
    }
  };
  const confirmDelete = async () => {
    setShowConfirmDelete(false);
    setLoading(true);
    try {
      const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/auth/credentials/${student._id}`, {
        method: 'DELETE'
      });
      if (!r.ok) throw new Error('Failed');
      alert('Deleted!');
      onCredentialsUpdate(null);
      onClose();
    } catch {
      alert('Failed to delete');
    } finally {
      setLoading(false);
    }
  };
  if (fetching) return <div style={{
    position: "fixed",
    inset: 0,
    background: "rgba(13,71,161,0.5)",
    zIndex: 2100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }} onClick={onClose}>
      <div style={{
      background: "#FFFFFF",
      borderRadius: 24,
      padding: 48,
      color: "#0D47A1"
    }}>Loading...</div>
    </div>;
  return <>
      <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(13,71,161,0.5)",
      zIndex: 2100,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(8px)"
    }} onClick={onClose}>
        <div style={{
        background: "#FFFFFF",
        borderRadius: 24,
        width: "min(500px, 90%)",
        fontFamily: "'Inter', sans-serif",
        maxHeight: "90vh",
        overflow: "auto",
        boxShadow: "0 40px 80px rgba(0,0,0,0.1)"
      }} onClick={e => e.stopPropagation()}>
          <div style={{
          background: "#0D47A1",
          padding: "24px 28px",
          borderRadius: "24px 24px 0 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}>
            <div>
              <div style={{
              fontWeight: 700,
              fontSize: 16,
              color: "#FFFFFF"
            }}>
                <i className="fas fa-lock" style={{
                marginRight: 8
              }}></i> Parent Login Credentials
              </div>
              <div style={{
              fontSize: 11,
              color: "rgba(255,255,255,0.8)",
              marginTop: 4
            }}>{student.studentName} · {student.applyingClass}-{student.section}</div>
            </div>
            <button onClick={onClose} style={{
            background: "rgba(255,255,255,0.2)",
            border: "none",
            color: "#FFFFFF",
            borderRadius: 12,
            width: 36,
            height: 36,
            fontSize: 16,
            cursor: "pointer"
          }}>
              <i className="fas fa-times"></i>
            </button>
          </div>
          <div style={{
          padding: 28
        }}>
            <div style={{
            background: "#E3F2FD",
            padding: 16,
            borderRadius: 16,
            marginBottom: 24
          }}>
              <div style={{
              fontSize: 11,
              color: "#0D47A1",
              marginBottom: 8
            }}>Student Details</div>
              <div style={{
              fontSize: 15,
              fontWeight: 700,
              color: "#0D47A1"
            }}>{student.studentName}</div>
              <div style={{
              fontSize: 11,
              color: "#0D47A1",
              marginTop: 4
            }}>Parent: {student.fatherName} · {student.applyingClass}-{student.section}</div>
            </div>
            <FLabel label="Username" required>
              <div style={{
              display: "flex",
              gap: 10
            }}>
                <Inp type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Enter username" />
                <button onClick={generateUsername} style={{
                background: "#2196F3",
                color: "#0D47A1",
                border: "none",
                padding: "0 16px",
                borderRadius: 12,
                fontSize: 12,
                cursor: "pointer",
                whiteSpace: "nowrap",
                fontWeight: 600
              }}>Random</button>
              </div>
            </FLabel>
            <FLabel label="Password" required>
              <div style={{
              display: "flex",
              gap: 10
            }}>
                <Inp type="text" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter password" />
                <button onClick={generatePassword} style={{
                background: "#2196F3",
                color: "#0D47A1",
                border: "none",
                padding: "0 16px",
                borderRadius: 12,
                fontSize: 12,
                cursor: "pointer",
                whiteSpace: "nowrap",
                fontWeight: 600
              }}>Generate</button>
              </div>
            </FLabel>
            {existingCreds && <div style={{
            padding: "12px 16px",
            background: "#E3F2FD",
            borderRadius: 12,
            fontSize: 11,
            color: "#0D47A1",
            marginBottom: 20,
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
                <i className="fas fa-exclamation-circle"></i> Existing credentials found. Update to change.
              </div>}
            <div style={{
            display: "flex",
            gap: 12,
            marginTop: 24
          }}>
              {existingCreds && <button onClick={() => setShowConfirmDelete(true)} disabled={loading} style={{
              flex: 1,
              background: "#E3F2FD",
              color: "#0D47A1",
              border: "1px solid #90CAF9",
              padding: 12,
              borderRadius: 12,
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer"
            }}>
                  <i className="fas fa-trash" style={{
                marginRight: 6
              }}></i>Delete
                </button>}
              <button onClick={onClose} style={{
              flex: 1,
              background: "#E3F2FD",
              color: "#0D47A1",
              border: "1px solid #90CAF9",
              padding: 12,
              borderRadius: 12,
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer"
            }}>Cancel</button>
              <button onClick={handleSubmit} disabled={loading} style={{
              flex: 2,
              background: loading ? "#0D47A1" : "#2196F3",
              color: loading ? "#FFFFFF" : "#0D47A1",
              border: "none",
              padding: 12,
              borderRadius: 12,
              fontSize: 12,
              fontWeight: 700,
              cursor: loading ? "not-allowed" : "pointer",
              boxShadow: loading ? "none" : "0 4px 14px rgba(33,150,243,0.3)"
            }}>
                {loading ? "Saving..." : existingCreds ? "Update" : "Generate & Save"}
              </button>
            </div>
          </div>
        </div>
      </div>
      {showConfirmDelete && <ConfirmDialog message={`Delete credentials for ${student.studentName}?`} onConfirm={confirmDelete} onCancel={() => setShowConfirmDelete(false)} />}
    </>;
}
function DetailModal({
  student,
  onClose,
  onUpdateStatus
}) {
  const [newStatus, setNewStatus] = useState(student.status);
  const [updating, setUpdating] = useState(false);
  const handleUpdate = async () => {
    setUpdating(true);
    try {
      const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/admissions/${student._id}/status`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          status: newStatus
        })
      });
      if (!r.ok) throw new Error('Failed');
      onUpdateStatus(student._id, newStatus);
      onClose();
    } catch {
      alert('Failed to update status.');
    } finally {
      setUpdating(false);
    }
  };
  return <div style={{
    position: "fixed",
    inset: 0,
    background: "rgba(13,71,161,0.5)",
    zIndex: 2000,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backdropFilter: "blur(8px)",
    padding: "20px 16px"
  }} onClick={onClose}>
      <div style={{
      background: "#FFFFFF",
      borderRadius: 28,
      width: "min(800px, 100%)",
      maxHeight: "90vh",
      overflow: "auto",
      boxShadow: "0 40px 80px rgba(0,0,0,0.1)",
      fontFamily: "'Inter', sans-serif"
    }} onClick={e => e.stopPropagation()}>
        <div style={{
        background: "#0D47A1",
        padding: "28px 32px",
        borderRadius: "28px 28px 0 0",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
          <div style={{
          display: "flex",
          gap: 18,
          alignItems: "center"
        }}>
            <Avatar name={student.studentName} idx={0} size={52} />
            <div>
              <div style={{
              fontWeight: 800,
              fontSize: 18,
              color: "#FFFFFF"
            }}>{student.studentName}</div>
              <div style={{
              fontSize: 12,
              color: "rgba(255,255,255,0.75)",
              marginTop: 4,
              display: "flex",
              flexWrap: "wrap",
              gap: 8
            }}>
                <span>{student.applyingClass}-{student.section}</span>
                {student.medium && <span>· {student.medium} Medium</span>}
                {student.group && <span>· {student.group}</span>}
                <span>· {student.enquiryDate}</span>
              </div>
            </div>
          </div>
          <div style={{
          display: "flex",
          gap: 12,
          alignItems: "center"
        }}>
            <StatusBadge status={student.status} />
            <button onClick={onClose} style={{
            background: "rgba(255,255,255,0.2)",
            border: "none",
            color: "#FFFFFF",
            borderRadius: 12,
            width: 36,
            height: 36,
            fontSize: 16,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
              <i className="fas fa-times"></i>
            </button>
          </div>
        </div>
        <div style={{
        padding: "32px"
      }}>
          <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "0 40px"
        }}>
            <div>
              <SecHead icon="fa-user-graduate" title="Student Details" />
              <DRow label="Full Name" value={student.studentName} />
              <DRow label="Date of Birth" value={student.dob} />
              <DRow label="Gender" value={student.gender} />
              <DRow label="Blood Group" value={student.bloodGroup} />
              <DRow label="Religion" value={student.religion} />
              <DRow label="Nationality" value={student.nationality} />
              <DRow label="Mother Tongue" value={student.motherTongue} />
              <DRow label="Aadhaar No" value={student.aadhaar} />
              <SecHead icon="fa-home" title="Address" />
              {student.address ? <div style={{
              fontSize: 12,
              color: "#0D47A1",
              lineHeight: 1.8
            }}>{student.address}<br />{student.city}{student.pincode ? ` – ${student.pincode}` : ""}</div> : <div style={{
              fontSize: 12,
              color: "#0D47A1"
            }}>Not provided</div>}
            </div>
            <div>
              <SecHead icon="fa-book" title="Academic Details" />
              <DRow label="Applying Class" value={`${student.applyingClass}-${student.section}`} />
              <DRow label="Medium" value={student.medium} />
              <DRow label="Group" value={student.group} />
              <DRow label="Previous School" value={student.prevSchool} />
              <DRow label="Previous Class" value={student.prevClass} />
              <DRow label="Board" value={student.prevBoard} />
              <DRow label="TC Number" value={student.tcNumber} />
              <SecHead icon="fa-users" title="Parent Details" />
              <DRow label="Father Name" value={student.fatherName} />
              <DRow label="Father Mobile" value={student.fatherMobile} />
              <DRow label="Father Occupation" value={student.fatherOccupation} />
              <DRow label="Father Aadhaar" value={student.fatherAadhaar} />
              <DRow label="Mother Name" value={student.motherName} />
              <DRow label="Mother Mobile" value={student.motherMobile} />
              <DRow label="Mother Occupation" value={student.motherOccupation} />
            </div>
          </div>
          {student.documents?.length > 0 && <>
              <SecHead icon="fa-file-alt" title="Documents Received" />
              <div style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 8
          }}>
                {student.documents.map(d => <span key={d} style={{
              background: "#2196F3",
              color: "#FFFFFF",
              fontSize: 11,
              padding: "5px 14px",
              borderRadius: 24,
              fontWeight: 600,
              display: "inline-flex",
              alignItems: "center",
              gap: 6
            }}>
                    <i className="fas fa-check-circle"></i> {d}
                  </span>)}
              </div>
            </>}
          {student.remarks && <>
              <SecHead icon="fa-pen" title="Remarks" />
              <div style={{
            fontSize: 13,
            color: "#0D47A1",
            background: "#E3F2FD",
            padding: "14px 18px",
            borderRadius: 14,
            lineHeight: 1.7
          }}>{student.remarks}</div>
            </>}
          <SecHead icon="fa-sync-alt" title="Update Status" />
          <div style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          flexWrap: "wrap"
        }}>
            <Sel value={newStatus} onChange={e => setNewStatus(e.target.value)} style={{
            width: "auto",
            minWidth: 200
          }}>
              {Object.keys(STATUS_CONFIG).map(s => <option key={s}>{s}</option>)}
            </Sel>
            <button onClick={handleUpdate} disabled={updating} style={{
            background: updating ? "#0D47A1" : "#2196F3",
            color: "#FFFFFF",
            border: "none",
            padding: "10px 24px",
            borderRadius: 12,
            fontSize: 13,
            fontWeight: 700,
            cursor: updating ? "not-allowed" : "pointer",
            boxShadow: updating ? "none" : "0 4px 14px rgba(33,150,243,0.3)"
          }}>
              {updating ? "Updating..." : "Update"}
            </button>
          </div>
        </div>
      </div>
    </div>;
}
function StaffAttendanceModal({
  onClose
}) {
  const todayISO = new Date().toISOString().split("T")[0];
  const [selectedDate, setSelectedDate] = useState(todayISO);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("all");
  const [leaveRequests, setLeaveRequests] = useState([]);
  const [leaveActionId, setLeaveActionId] = useState(null);
  const DEPT_COLORS = {
    Maths: {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    Science: {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    Tamil: {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    English: {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    Social: {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    Admin: {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    "Bio Maths": {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    "Computer Science": {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    "Art & Science": {
      bg: "#E3F2FD",
      color: "#0D47A1"
    },
    "Commerce": {
      bg: "#E3F2FD",
      color: "#0D47A1"
    }
  };
  const statusCfg = {
    present: {
      bg: "#1B5E20",
      color: "#FFFFFF",
      icon: "fa-check-circle",
      label: "Present"
    },
    late: {
      bg: "#FFCDD2",
      color: "#B71C1C",
      icon: "fa-clock",
      label: "Late"
    },
    leave: {
      bg: "#1565C0",
      color: "#FFFFFF",
      icon: "fa-calendar-times",
      label: "Leave"
    },
    absent: {
      bg: "#B71C1C",
      color: "#FFFFFF",
      icon: "fa-times-circle",
      label: "Absent"
    }
  };
  useEffect(() => {
    const fetchRecords = async () => {
      setLoading(true);
      setFilter("all");
      try {
        const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff-attendance/today?date=${selectedDate}`);
        if (r.ok) {
          const data = await r.json();
          setRecords(Array.isArray(data) ? data : []);
        } else {
          setRecords([]);
        }
      } catch (err) {
        console.error("Error fetching staff attendance:", err);
        setRecords([]);
      } finally {
        setLoading(false);
      }
    };
    fetchRecords();
  }, [selectedDate]);
  const fetchLeaveRequests = async () => {
    try {
      const r = await fetch("https://schoolcrm-fzcv.onrender.com/api/leave-requests/pending");
      if (r.ok) {
        const data = await r.json();
        setLeaveRequests(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      console.error("Error fetching leave requests:", err);
    }
  };
  useEffect(() => {
    fetchLeaveRequests();
  }, []);
  const handleApproveLeave = async id => {
    setLeaveActionId(id);
    try {
      const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/leave-requests/${id}/approve`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      });
      if (r.ok) {
        await fetchLeaveRequests();
        const attendanceRes = await fetch(`https://schoolcrm-fzcv.onrender.com/api/staff-attendance/today?date=${selectedDate}`);
        if (attendanceRes.ok) setRecords(await attendanceRes.json());
      } else {
        console.error("Failed to approve leave request", r.status, r.statusText);
      }
    } catch (err) {
      console.error("Error approving leave:", err);
    }
    setLeaveActionId(null);
  };
  const handleRejectLeave = async id => {
    setLeaveActionId(id);
    try {
      const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/leave-requests/${id}/reject`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({})
      });
      if (r.ok) {
        await fetchLeaveRequests();
      } else {
        console.error("Failed to reject leave request", r.status, r.statusText);
      }
    } catch (err) {
      console.error("Error rejecting leave:", err);
    }
    setLeaveActionId(null);
  };
  const counts = {
    present: records.filter(r => r.status === "present").length,
    late: records.filter(r => r.status === "late").length,
    leave: records.filter(r => r.status === "leave").length,
    absent: records.filter(r => r.status === "absent").length
  };
  const filtered = filter === "all" ? records : records.filter(r => r.status === filter);
  const getStaffName = rec => rec.staffId?.name || rec.name || "Unknown";
  const getStaffDept = rec => rec.staffId?.dept || rec.dept || "";
  const getStaffRole = rec => rec.staffId?.role || rec.role || "";
  const dateLabel = new Date(selectedDate + "T00:00:00").toLocaleDateString("en-IN", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric"
  });
  const isToday = selectedDate === todayISO;
  const shiftDate = days => {
    const d = new Date(selectedDate + "T00:00:00");
    d.setDate(d.getDate() + days);
    setSelectedDate(d.toISOString().split("T")[0]);
  };
  return <div style={{
    position: "fixed",
    inset: 0,
    background: "rgba(13,71,161,0.55)",
    zIndex: 2300,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
    backdropFilter: "blur(8px)"
  }} onClick={onClose}>
      <div onClick={e => e.stopPropagation()} style={{
      background: "#FFFFFF",
      borderRadius: 24,
      width: "min(900px, 98%)",
      maxHeight: "92vh",
      display: "flex",
      flexDirection: "column",
      boxShadow: "0 40px 80px rgba(0,0,0,0.1)",
      fontFamily: "'Inter', sans-serif",
      overflow: "hidden"
    }}>
        <div style={{
        background: "#0D47A1",
        padding: "20px 28px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexShrink: 0
      }}>
          <div style={{
          display: "flex",
          alignItems: "center",
          gap: 12
        }}>
            <div style={{
            width: 40,
            height: 40,
            borderRadius: 12,
            background: "rgba(255,255,255,0.15)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
              <i className="fas fa-user-clock" style={{
              color: "#FFFFFF",
              fontSize: 18
            }}></i>
            </div>
            <div>
              <div style={{
              fontWeight: 800,
              fontSize: 16,
              color: "#FFFFFF"
            }}>Staff Attendance</div>
              <div style={{
              fontSize: 11,
              color: "rgba(255,255,255,0.8)",
              marginTop: 2
            }}>{dateLabel}{isToday ? " · Today" : ""}</div>
            </div>
          </div>
          <button onClick={onClose} style={{
          background: "rgba(255,255,255,0.1)",
          border: "none",
          color: "#FFFFFF",
          borderRadius: 10,
          width: 36,
          height: 36,
          fontSize: 15,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        {leaveRequests.length > 0 && <div style={{
        background: "#FFF3E0",
        padding: "16px 24px",
        flexShrink: 0,
        borderBottom: "1px solid #FFE0B2"
      }}>
            <div style={{
          fontSize: 11,
          fontWeight: 700,
          color: "#E65100",
          textTransform: "uppercase",
          letterSpacing: "0.6px",
          marginBottom: 10,
          display: "flex",
          alignItems: "center",
          gap: 6
        }}>
              <i className="fas fa-hourglass-half"></i> Pending Leave Requests ({leaveRequests.length})
            </div>
            <div style={{
          display: "grid",
          gap: 10
        }}>
              {leaveRequests.map(req => <div key={req._id} style={{
            background: "#FFFFFF",
            borderRadius: 12,
            padding: "12px 16px",
            border: "1px solid #FFE0B2",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12
          }}>
                  <div style={{
              minWidth: 200
            }}>
                    <div style={{
                fontWeight: 700,
                fontSize: 13,
                color: "#0D47A1"
              }}>
                      {req.employeeName}
                      {req.employeeDept && <span style={{
                  marginLeft: 8,
                  fontSize: 10,
                  fontWeight: 600,
                  color: "#0D47A1",
                  background: "#E3F2FD",
                  padding: "2px 8px",
                  borderRadius: 24
                }}>{req.employeeDept}</span>}
                    </div>
                    <div style={{
                fontSize: 10,
                color: "#8199BC",
                marginTop: 2
              }}>
                      ID: {req._id} &nbsp;·&nbsp; Date: {req.date}
                    </div>
                    {req.reason && <div style={{
                fontSize: 12,
                color: "#5C7A9C",
                marginTop: 4,
                fontStyle: "italic"
              }}>
                        <i className="fas fa-sticky-note" style={{
                  marginRight: 5
                }}></i>{req.reason}
                      </div>}
                  </div>
                  <div style={{
              display: "flex",
              gap: 8
            }}>
                    <button onClick={() => handleApproveLeave(req._id)} disabled={leaveActionId === req._id} style={{
                background: "#0D47A1",
                color: "#FFFFFF",
                border: "none",
                borderRadius: 8,
                padding: "8px 16px",
                fontSize: 12,
                fontWeight: 700,
                cursor: leaveActionId === req._id ? "not-allowed" : "pointer",
                opacity: leaveActionId === req._id ? 0.6 : 1
              }}>
                      <i className="fas fa-check" style={{
                  marginRight: 6
                }}></i>Approve
                    </button>
                    <button onClick={() => handleRejectLeave(req._id)} disabled={leaveActionId === req._id} style={{
                background: "#FFFFFF",
                color: "#C62828",
                border: "1px solid #C62828",
                borderRadius: 8,
                padding: "8px 16px",
                fontSize: 12,
                fontWeight: 700,
                cursor: leaveActionId === req._id ? "not-allowed" : "pointer",
                opacity: leaveActionId === req._id ? 0.6 : 1
              }}>
                      <i className="fas fa-times" style={{
                  marginRight: 6
                }}></i>Reject
                    </button>
                  </div>
                </div>)}
            </div>
          </div>}

        <div style={{
        background: "#E3F2FD",
        padding: "14px 24px",
        display: "flex",
        alignItems: "center",
        gap: 12,
        flexShrink: 0,
        flexWrap: "wrap"
      }}>
          <span style={{
          fontSize: 11,
          fontWeight: 700,
          color: "#0D47A1",
          textTransform: "uppercase",
          letterSpacing: "0.6px"
        }}>
            <i className="fas fa-calendar-alt" style={{
            marginRight: 6,
            color: "#0D47A1"
          }}></i>Select Date
          </span>
          <button onClick={() => shiftDate(-1)} style={{
          background: "#FFFFFF",
          borderRadius: 10,
          width: 34,
          height: 34,
          cursor: "pointer",
          fontSize: 13,
          color: "#0D47A1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          border: "1px solid #90CAF9"
        }}>
            <i className="fas fa-chevron-left"></i>
          </button>
          <input type="date" value={selectedDate} max={todayISO} onChange={e => e.target.value && setSelectedDate(e.target.value)} style={{
          borderRadius: 10,
          padding: "6px 12px",
          fontSize: 13,
          fontFamily: "'Inter',sans-serif",
          color: "#0D47A1",
          outline: "none",
          cursor: "pointer",
          background: "#FFFFFF",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          border: "1px solid #90CAF9"
        }} />
          <button onClick={() => shiftDate(1)} disabled={isToday} style={{
          background: "#FFFFFF",
          borderRadius: 10,
          width: 34,
          height: 34,
          cursor: isToday ? "not-allowed" : "pointer",
          fontSize: 13,
          color: isToday ? "#90CAF9" : "#0D47A1",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
          border: isToday ? "1px solid #90CAF9" : "1px solid #90CAF9"
        }}>
            <i className="fas fa-chevron-right"></i>
          </button>
          {!isToday && <button onClick={() => setSelectedDate(todayISO)} style={{
          background: "#0D47A1",
          color: "#FFFFFF",
          border: "none",
          borderRadius: 8,
          padding: "6px 16px",
          fontSize: 11,
          fontWeight: 700,
          cursor: "pointer"
        }}>
              Today
            </button>}
          <div style={{
          marginLeft: "auto",
          fontSize: 11,
          color: "#0D47A1"
        }}>
            {records.length} record{records.length !== 1 ? "s" : ""} found
          </div>
        </div>

        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: 0,
        flexShrink: 0
      }}>
          {[{
          key: "present",
          label: "Present",
          color: "#FFFFFF",
          bg: "#1B5E20",
          icon: "fa-check-circle"
        }, {
          key: "late",
          label: "Late",
          color: "#B71C1C",
          bg: "#FFCDD2",
          icon: "fa-clock"
        }, {
          key: "leave",
          label: "On Leave",
          color: "#FFFFFF",
          bg: "#1565C0",
          icon: "fa-calendar-times"
        }, {
          key: "absent",
          label: "Absent",
          color: "#FFFFFF",
          bg: "#B71C1C",
          icon: "fa-times-circle"
        }].map(({
          key,
          label,
          color,
          bg,
          icon
        }) => {
          const active = filter === key;
          return <div key={key} onClick={() => setFilter(active ? "all" : key)} style={{
            padding: "16px 12px",
            background: active ? "#0D47A1" : bg,
            cursor: "pointer",
            transition: "background 0.2s",
            textAlign: "center",
            userSelect: "none",
            borderBottom: active ? "none" : "1px solid #E3F2FD"
          }}>
                <div style={{
              fontSize: 32,
              fontWeight: 800,
              color: active ? "#FFFFFF" : color,
              lineHeight: 1
            }}>{counts[key]}</div>
                <div style={{
              fontSize: 9,
              color: active ? "#FFFFFF" : color,
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              marginTop: 6,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 4
            }}>
                  <i className={`fas ${icon}`}></i> {label}
                </div>
                {active && <div style={{
              width: 30,
              height: 3,
              background: "#2196F3",
              borderRadius: 2,
              margin: "8px auto 0"
            }} />}
              </div>;
        })}
        </div>

        <div style={{
        padding: "12px 24px",
        display: "flex",
        gap: 8,
        flexWrap: "wrap",
        flexShrink: 0,
        background: "#E3F2FD",
        alignItems: "center"
      }}>
          <span style={{
          fontSize: 10,
          color: "#0D47A1",
          fontWeight: 600,
          marginRight: 6
        }}>FILTER:</span>
          {["all", "present", "late", "leave", "absent"].map(f => <button key={f} onClick={() => setFilter(f)} style={{
          padding: "4px 14px",
          borderRadius: 24,
          fontSize: 11,
          cursor: "pointer",
          fontWeight: filter === f ? 700 : 400,
          background: filter === f ? "#0D47A1" : "transparent",
          color: filter === f ? "#FFFFFF" : "#0D47A1",
          textTransform: "capitalize",
          boxShadow: filter === f ? "0 2px 8px rgba(13,71,161,0.2)" : "none",
          border: filter === f ? "none" : "1px solid #90CAF9"
        }}>
              {f === "all" ? `All (${records.length})` : `${f} (${counts[f] ?? 0})`}
            </button>)}
        </div>

        <div style={{
        overflowY: "auto",
        flex: 1
      }}>
          {loading ? <div style={{
          padding: 60,
          textAlign: "center",
          color: "#0D47A1"
        }}>
              <i className="fas fa-spinner fa-pulse" style={{
            fontSize: 32,
            marginBottom: 12,
            display: "block"
          }}></i>
              Loading attendance for {dateLabel}...
            </div> : filtered.length === 0 ? <div style={{
          padding: 60,
          textAlign: "center",
          color: "#0D47A1"
        }}>
              <i className="fas fa-calendar-times" style={{
            fontSize: 40,
            marginBottom: 14,
            display: "block"
          }}></i>
              <div style={{
            fontWeight: 600,
            marginBottom: 6,
            fontSize: 14
          }}>
                {records.length === 0 ? "No attendance records" : "No records match this filter"}
              </div>
              <div style={{
            fontSize: 12
          }}>
                {records.length === 0 ? `No staff marked attendance on ${dateLabel}` : "Try selecting a different filter"}
              </div>
            </div> : <div style={{
          padding: "16px 24px",
          display: "grid",
          gap: 12
        }}>
              {filtered.map((rec, idx) => {
            const name = getStaffName(rec);
            const dept = getStaffDept(rec);
            const role = getStaffRole(rec);
            const sc = statusCfg[rec.status] || statusCfg.absent;
            const dc = DEPT_COLORS[dept] || {
              bg: "#E3F2FD",
              color: "#0D47A1"
            };
            return <div key={rec._id || idx} style={{
              borderRadius: 16,
              overflow: "hidden",
              background: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
              border: "1px solid #90CAF9"
            }}>
                    <div style={{
                display: "flex",
                alignItems: "center"
              }}>
                      <div style={{
                  width: 6,
                  alignSelf: "stretch",
                  background: sc.bg,
                  flexShrink: 0
                }} />
                      <div style={{
                  flex: 1,
                  padding: "14px 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                  gap: 12
                }}>
                        <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 14
                  }}>
                          <div style={{
                      width: 46,
                      height: 46,
                      borderRadius: 14,
                      background: dc.bg,
                      color: dc.color,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontWeight: 800,
                      fontSize: 16,
                      flexShrink: 0,
                      border: "1px solid #90CAF9"
                    }}>
                            {name.slice(0, 2).toUpperCase()}
                          </div>
                          <div>
                            <div style={{
                        fontWeight: 700,
                        fontSize: 14,
                        color: "#0D47A1"
                      }}>{name}</div>
                            <div style={{
                        fontSize: 11,
                        color: "#0D47A1",
                        marginTop: 3,
                        display: "flex",
                        alignItems: "center",
                        gap: 8
                      }}>
                              {role && <span>{role}</span>}
                              {dept && <span style={{
                          background: dc.bg,
                          color: dc.color,
                          padding: "2px 10px",
                          borderRadius: 24,
                          fontWeight: 600,
                          fontSize: 10,
                          border: "1px solid #90CAF9"
                        }}>{dept}</span>}
                            </div>
                          </div>
                        </div>
                        <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 16
                  }}>
                          {rec.time && <div style={{
                      fontSize: 11,
                      color: "#0D47A1",
                      display: "flex",
                      alignItems: "center",
                      gap: 6
                    }}>
                              <i className="far fa-clock"></i> {rec.time}
                            </div>}
                          <span style={{
                      background: sc.bg,
                      color: sc.color,
                      padding: "5px 14px",
                      borderRadius: 24,
                      fontSize: 11,
                      fontWeight: 700,
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 6,
                      boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
                    }}>
                            <i className={`fas ${sc.icon}`}></i> {sc.label}
                          </span>
                        </div>
                      </div>
                    </div>
                    {rec.note && <div style={{
                paddingLeft: 80,
                paddingRight: 20,
                paddingBottom: 12,
                fontSize: 11,
                color: "#0D47A1",
                fontStyle: "italic",
                display: "flex",
                alignItems: "center",
                gap: 6
              }}>
                        <i className="fas fa-sticky-note"></i> {rec.note}
                      </div>}
                  </div>;
          })}
            </div>}
        </div>
      </div>
    </div>;
}
export default function AdmissionPage() {
  const [admissions, setAdmissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(emptyForm);
  const [filterStatus, setFilterStatus] = useState("All");
  const [showForm, setShowForm] = useState(false);
  const [viewStudent, setViewStudent] = useState(null);
  const [showCredentialsModal, setShowCredentialsModal] = useState(null);
  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [showStaffAttendance, setShowStaffAttendance] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [showAdmissionTable, setShowAdmissionTable] = useState(false);
  const [yearInput, setYearInput] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [searchFocused, setSearchFocused] = useState(false);
  const [unreadPrincipalMsgs, setUnreadPrincipalMsgs] = useState(0);
  const [pendingLeaveCount, setPendingLeaveCount] = useState(0);
  const schoolName = useSchoolName();
  const [showQrModal, setShowQrModal] = useState(false);

  // Public, no-login form URL — scanning this QR opens the same Admission
  // Enquiry form on any phone. Submitting it stores data straight into the
  // same admissions table shown below (via the existing POST /api/admissions).
  const publicFormUrl = `${window.location.protocol}//${window.location.hostname}:5000/api/admissions/public-form`;
  const qrImageUrl = `https://api.qrserver.com/v1/create-qr-code/?size=240x240&data=${encodeURIComponent(publicFormUrl)}`;
  const handlePrintQrCode = () => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Please allow pop-ups to print the QR code.");
      return;
    }
    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>QR Code</title>
          <meta charset="utf-8" />
          <style>
            body { font-family: Arial, sans-serif; color: #0D47A1; text-align: center; padding: 40px 20px; }
            h1 { font-size: 18px; margin-bottom: 4px; }
            .sub { font-size: 12px; color: #0D47A1; margin-bottom: 24px; }
            img { width: 260px; height: 260px; border: 1px solid #90CAF9; border-radius: 12px; padding: 12px; }
            .url { font-size: 10px; color: #2196F3; margin-top: 18px; word-break: break-all; }
          </style>
        </head>
        <body>
          <h1>QR Code</h1>
          <div class="sub">Scan to open the Admission Enquiry form</div>
          <img src="${qrImageUrl}" alt="QR Code" />
          <div class="url">${publicFormUrl}</div>
        </body>
      </html>
    `;
    printWindow.document.open();
    printWindow.document.write(printHtml);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  };
  const navigate = useNavigate();

  // Poll for unread messages from the Principal, to badge the
  // "Principal Message" quick-nav card.
  useEffect(() => {
    const fetchUnread = async () => {
      try {
        const r = await fetch('https://schoolcrm-fzcv.onrender.com/api/principal-messages');
        if (!r.ok) {
          console.error('Principal Message badge: server responded', r.status, r.statusText);
          return;
        }
        const j = await r.json();
        if (j.success) {
          const count = (j.messages || []).filter(m => m.sender === 'principal' && !m.read).length;
          setUnreadPrincipalMsgs(count);
        } else {
          console.error('Principal Message badge: API returned success=false', j.error);
        }
      } catch (err) {
        console.error('Principal Message badge: fetch failed', err);
      }
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 8000);
    return () => clearInterval(interval);
  }, []);

  // Poll for pending leave requests, to badge the "Staff Leave" quick-nav card.
  useEffect(() => {
    const fetchPendingLeave = async () => {
      try {
        const r = await fetch('https://schoolcrm-fzcv.onrender.com/api/leave-requests/pending');
        if (!r.ok) {
          console.error('Staff Leave badge: server responded', r.status, r.statusText);
          return;
        }
        const data = await r.json();
        setPendingLeaveCount(Array.isArray(data) ? data.length : 0);
      } catch (err) {
        console.error('Staff Leave badge: fetch failed', err);
      }
    };
    fetchPendingLeave();
    const interval = setInterval(fetchPendingLeave, 8000);
    return () => clearInterval(interval);
  }, []);
  const isHighSchool = HIGH_SCHOOL_CLASSES.includes(form.applyingClass);
  const fetchAdmissions = async () => {
    try {
      const r = await fetch('https://schoolcrm-fzcv.onrender.com/api/admissions');
      if (!r.ok) throw new Error('Failed');
      setAdmissions(await r.json());
    } catch {} finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAdmissions();
  }, []);
  const setField = field => e => {
    const val = e && e.target ? e.target.value : e;
    setForm(prev => {
      const next = {
        ...prev,
        [field]: val
      };
      if (field === "applyingClass" && !HIGH_SCHOOL_CLASSES.includes(val)) {
        next.group = "";
        next.groupCategory = "";
      }
      return next;
    });
    if (errors[field]) setErrors(er => ({
      ...er,
      [field]: null
    }));
  };
  const toggleDoc = doc => setForm(f => ({
    ...f,
    documents: f.documents.includes(doc) ? f.documents.filter(d => d !== doc) : [...f.documents, doc]
  }));
  const validate = () => {
    const e = {};
    if (!form.studentName.trim()) e.studentName = "Required";
    if (!form.dob) e.dob = "Required";
    if (!form.gender) e.gender = "Required";
    if (!form.applyingClass) e.applyingClass = "Required";
    if (!form.section) e.section = "Please select section";
    if (!form.medium) e.medium = "Required";
    if (!form.fatherName.trim()) e.fatherName = "Required";
    if (!form.fatherMobile || !/^\d{10}$/.test(form.fatherMobile)) e.fatherMobile = "Valid 10-digit mobile needed";
    if (isHighSchool && !form.group) e.group = "Required for Class 11 & 12";
    return e;
  };
  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) {
      setErrors(e);
      return;
    }
    setSubmitting(true);
    try {
      const r = await fetch('https://schoolcrm-fzcv.onrender.com/api/admissions', {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form)
      });
      if (!r.ok) throw new Error('Failed');
      const newAdmission = await r.json();
      setAdmissions(prev => [newAdmission, ...prev]);
      setForm(emptyForm);
      setErrors({});
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3500);
      setShowForm(false);
    } catch {
      alert('Failed to submit. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };
  const updateStatus = async (id, status) => {
    try {
      const r = await fetch(`https://schoolcrm-fzcv.onrender.com/api/admissions/${id}/status`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          status
        })
      });
      if (!r.ok) throw new Error('Failed');
      const updated = await r.json();
      setAdmissions(prev => prev.map(s => s._id === id ? updated : s));
    } catch {
      alert('Failed to update status.');
    }
  };

  // Academic year filter: expects "YYYY-YYYY" (e.g. 2026-2027), covers Apr 1 (start) to Mar 31 (end)
  const parseAcademicYear = val => {
    const m = (val || "").trim().match(/^(\d{4})-(\d{4})$/);
    if (!m) return null;
    return {
      start: `${m[1]}-04-01`,
      end: `${m[2]}-03-31`
    };
  };
  const academicYearRange = parseAcademicYear(yearInput);

  // ── Search filter ────────────────────────────────────────────────────────
  // If the query is PURE DIGITS (e.g. "9", "8", "10"), the person almost
  // always means "Class 9 / Class 8 / Class 10" — so we match against the
  // class number ONLY. Previously this also matched against father/mother
  // mobile numbers via `.includes(q)`, so typing "9" pulled in totally
  // unrelated classes just because someone's phone number contained a 9.
  // Non-numeric queries keep matching name/class/section/phone as before.
  const filtered = admissions.filter(s => filterStatus === "All" ? true : s.status === filterStatus).filter(s => {
    if (!academicYearRange) return true;
    if (!s.enquiryDate) return false;
    return s.enquiryDate >= academicYearRange.start && s.enquiryDate <= academicYearRange.end;
  }).filter(s => {
    const q = searchQuery.trim().toLowerCase();
    if (!q) return true;
    const classDigits = (s.applyingClass || "").replace(/[^0-9]/g, ""); // "Class 9" -> "9"
    const isNumericQuery = /^\d+$/.test(q);
    if (isNumericQuery) {
      // Numbers-only search → match by class number only, not phone digits.
      return classDigits !== "" && (classDigits === q || classDigits.startsWith(q));
    }
    const classSection = `${s.applyingClass || ""}-${s.section || ""}`.toLowerCase();
    return (s.studentName || "").toLowerCase().includes(q) || (s.fatherName || "").toLowerCase().includes(q) || (s.motherName || "").toLowerCase().includes(q) || (s.fatherMobile || "").includes(q) || (s.motherMobile || "").includes(q) || (s.applyingClass || "").toLowerCase().includes(q) || (s.section || "").toLowerCase().includes(q) || classSection.includes(q);
  });
  const handlePrintDownload = () => {
    const rows = filtered.map(s => `
      <tr>
        <td>${s.studentName || ""}</td>
        <td>${s.applyingClass || ""}${s.section ? "-" + s.section : ""}</td>
        <td>${s.medium || ""}</td>
        <td>${s.fatherName || ""}</td>
        <td>${s.fatherMobile || ""}</td>
        <td>${s.enquiryDate || ""}</td>
        <td>${s.status || ""}</td>
      </tr>
    `).join("");
    const title = academicYearRange ? `Admissions ${yearInput}` : "All Admissions";
    const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>${title}</title>
          <meta charset="utf-8" />
          <style>
            body { font-family: Arial, sans-serif; padding: 24px; color: #0D47A1; }
            h1 { font-size: 18px; margin-bottom: 4px; }
            .sub { font-size: 12px; color: #0D47A1; margin-bottom: 20px; }
            table { width: 100%; border-collapse: collapse; font-size: 12px; }
            th, td { border: 1px solid #2196F3; padding: 8px 10px; text-align: left; }
            th { background: #0D47A1; color: #ffffff; text-transform: uppercase; font-size: 10px; letter-spacing: 0.5px; }
            tr:nth-child(even) { background: #E3F2FD; }
          </style>
        </head>
        <body>
          <h1>${title}</h1>
          <div class="sub">Total Students: ${filtered.length} · Generated on ${new Date().toLocaleDateString("en-IN")}</div>
          <table>
            <thead>
              <tr>
                <th>Student Name</th>
                <th>Class</th>
                <th>Medium</th>
                <th>Parent Name</th>
                <th>Parent Mobile</th>
                <th>Enquiry Date</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              ${rows || `<tr><td colspan="7" style="text-align:center;">No students found</td></tr>`}
            </tbody>
          </table>
        </body>
      </html>
    `;
    const printWindow = window.open("", "_blank");
    if (!printWindow) {
      alert("Please allow pop-ups to print/download.");
      return;
    }
    printWindow.document.open();
    printWindow.document.write(printHtml);
    printWindow.document.close();
    printWindow.onload = () => {
      printWindow.focus();
      printWindow.print();
    };
  };

  // ===== NAVIGATION BUTTONS (8 Cards - Carousel with 3 visible) =====
  const navCards = [{
    label: "Circulars",
    icon: "fa-bullhorn",
    path: "/admin-circular",
    proverb: "Knowledge is power.",
    theme: {
      grad: ["#90CAF9", "#2196F3"],
      text: "#0D47A1"
    }
  }, {
    label: "Staff Leave",
    icon: "fa-user-clock",
    action: "attendance",
    proverb: "Rest when you're weary. Refresh and renew yourself.",
    theme: {
      grad: ["#90CAF9", "#90CAF9"],
      text: "#0D47A1"
    },
    badge: pendingLeaveCount
  }, {
    label: "Principal Message",
    icon: "fa-comments",
    path: "/admin-principal-messages",
    proverb: "A private word carries public trust.",
    theme: {
      grad: ["#2196F3", "#90CAF9"],
      text: "#0D47A1"
    },
    badge: unreadPrincipalMsgs
  }, {
    label: "Fees",
    icon: "fa-graduation-cap",
    path: "/fees",
    proverb: "Education is the most powerful weapon.",
    theme: {
      grad: ["#0D47A1", "#0D47A1"],
      text: "#FFFFFF"
    }
  }, {
    label: "Staff Analysis",
    icon: "fa-chart-line",
    path: "/staff-analysis",
    proverb: "What gets measured gets managed.",
    theme: {
      grad: ["#0D47A1", "#2196F3"],
      text: "#FFFFFF"
    }
  }, {
    label: "Staff",
    icon: "fa-chalkboard-teacher",
    path: "/staff",
    proverb: "Alone we can do so little; together we can do so much.",
    theme: {
      grad: ["#2196F3", "#0D47A1"],
      text: "#FFFFFF"
    }
  }, {
    label: "Workers",
    icon: "fa-hard-hat",
    path: "/workers",
    proverb: "The best way to find yourself is to lose yourself in the service of others.",
    theme: {
      grad: ["#2196F3", "#90CAF9"],
      text: "#0D47A1"
    }
  }, {
    label: "Timetable",
    icon: "fa-calendar-alt",
    path: "/timetable",
    proverb: "Time is the wisest counsellor of all.",
    theme: {
      grad: ["#2196F3", "#2196F3"],
      text: "#FFFFFF"
    }
  }, {
    label: "Donations",
    icon: "fa-hand-holding-heart",
    path: "/donations",
    proverb: "The hand that gives, gathers.",
    theme: {
      grad: ["#0D47A1", "#0D47A1"],
      text: "#FFFFFF"
    }
  }, {
    label: "Salary",
    icon: "fa-wallet",
    path: "/salary",
    proverb: "A fair day's wage for a fair day's work.",
    theme: {
      grad: ["#0D47A1", "#0D47A1"],
      text: "#FFFFFF"
    }
  }];
  const cardsPerPage = 5;
  const totalPages = Math.ceil(navCards.length / cardsPerPage);
  const goToPrev = () => {
    setCarouselIndex(prev => (prev - 1 + totalPages) % totalPages);
  };
  const goToNext = () => {
    setCarouselIndex(prev => (prev + 1) % totalPages);
  };
  const getVisibleCards = () => {
    const start = carouselIndex * cardsPerPage;
    return navCards.slice(start, start + cardsPerPage);
  };

  // ===== HERO SECTION - Multi-Color Background =====
  const HeroSection = () => <div className="hero-section" style={{
    background: "linear-gradient(135deg, #0D47A1 0%, #0D47A1 50%, #2196F3 100%)",
    padding: "50px 40px",
    margin: "20px 24px 0",
    borderRadius: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 40,
    boxShadow: "0 8px 32px rgba(13,71,161,0.2)",
    flexWrap: "wrap",
    position: "relative",
    overflow: "hidden"
  }}>
      <div className="hero-circle hero-circle-1"></div>
      <div className="hero-circle hero-circle-2"></div>
      <div className="hero-circle hero-circle-3"></div>
      <div className="hero-circle hero-circle-4"></div>
      <div className="hero-circle hero-circle-5"></div>
      <div className="hero-circle hero-circle-6"></div>
      <div className="hero-circle hero-circle-7"></div>
      <div className="hero-circle hero-circle-8"></div>
      <div className="hero-circle hero-circle-9"></div>
      <div className="hero-text-wrap" style={{
      flex: 1,
      minWidth: "280px"
    }}>
        <div className="hero-text" style={{
        fontSize: 38,
        fontWeight: 800,
        color: "#FFFFFF",
        lineHeight: 1.2,
        marginBottom: 12
      }}>
          <span style={{
          color: "rgb(140, 169, 255)"
        }}>Empowering</span> Future Leaders
        </div>
        <div style={{
        fontSize: 15,
        color: "#FFFFFF",
        lineHeight: 1.8,
        marginBottom: 20,
        maxWidth: "500px"
      }}>
          At <strong style={{
          color: "#FFFFFF"
        }}>{schoolName}</strong>, we believe in nurturing young minds with 
          quality education, character building, and holistic development. 
          Join us in shaping tomorrow's visionaries.
        </div>
        <button onClick={() => setShowForm(true)} style={{
        background: "rgb(33, 150, 243)",
        color: "#FFFFFF",
        border: "none",
        padding: "12px 32px",
        borderRadius: 12,
        fontSize: 15,
        fontWeight: 700,
        cursor: "pointer",
        boxShadow: "0 4px 14px rgba(33,150,243,0.3)",
        transition: "all 0.2s",
        display: "inline-flex",
        alignItems: "center",
        gap: 8
      }} onMouseEnter={e => e.target.style.transform = "translateY(-2px)"} onMouseLeave={e => e.target.style.transform = "translateY(0)"}>
          <i className="fas fa-plus-circle"></i> Admission Add
        </button>
      </div>
      <div className="hero-image" style={{
      flex: "0 0 480px",
      height: 280,
      borderRadius: 16,
      overflow: "hidden",
      position: "relative",
      boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
      width: "100%",
      maxWidth: "600px"
    }}>
        <img src="https://images.unsplash.com/photo-1775623606576-3e049f72b8e7?fm=jpg&q=80&w=800&auto=format&fit=crop" alt={`${schoolName}  students celebrating success`} style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
        display: "block"
      }} />
        <div style={{
        position: "absolute",
        inset: 0,
        background: "linear-gradient(0deg, rgba(13,71,161,0.7) 0%, rgba(13,71,161,0.05) 55%, rgba(13,71,161,0) 100%)",
        display: "flex",
        alignItems: "flex-end",
        padding: "16px 20px"
      }}>
          <span style={{
          fontSize: 16,
          fontWeight: 700,
          color: "#FFFFFF",
          letterSpacing: "0.2px"
        }}>{schoolName} </span>
        </div>
      </div>
    </div>;
  if (loading) return <div style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    background: "#FFFFFF",
    fontFamily: "'Inter', sans-serif"
  }}>
      <style>{`
        @keyframes capBounce {
          0%, 100% { transform: translateY(0) rotate(0deg); }
          50% { transform: translateY(-14px) rotate(-6deg); }
        }
        @keyframes tasselSwing {
          0%, 100% { transform: rotate(-8deg); }
          50% { transform: rotate(8deg); }
        }
        @keyframes bookPulse1 { 0%, 100% { transform: scaleY(1); } 50% { transform: scaleY(1.15); } }
        @keyframes bookPulse2 { 0%, 100% { transform: scaleY(1); } 50% { transform: scaleY(1.15); } }
        @keyframes bookPulse3 { 0%, 100% { transform: scaleY(1); } 50% { transform: scaleY(1.15); } }
        @keyframes dotBlink {
          0%, 80%, 100% { opacity: 0.25; }
          40% { opacity: 1; }
        }
      `}</style>
      <div style={{
      textAlign: "center"
    }}>
        <div style={{
        position: "relative",
        width: 90,
        height: 90,
        margin: "0 auto 22px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        gap: 5
      }}>
          <div style={{
          width: 14,
          height: 34,
          background: "#2196F3",
          borderRadius: "2px 2px 0 0",
          animation: "bookPulse1 1.2s ease-in-out infinite",
          transformOrigin: "bottom"
        }} />
          <div style={{
          width: 14,
          height: 44,
          background: "#1565C0",
          borderRadius: "2px 2px 0 0",
          animation: "bookPulse2 1.2s ease-in-out infinite 0.15s",
          transformOrigin: "bottom"
        }} />
          <div style={{
          width: 14,
          height: 28,
          background: "#42A5F5",
          borderRadius: "2px 2px 0 0",
          animation: "bookPulse3 1.2s ease-in-out infinite 0.3s",
          transformOrigin: "bottom"
        }} />
          <div style={{
          position: "absolute",
          top: -6,
          left: "50%",
          transform: "translateX(-50%)",
          animation: "capBounce 1.4s ease-in-out infinite"
        }}>
            <i className="fas fa-graduation-cap" style={{
            fontSize: 36,
            color: "#0D47A1",
            filter: "drop-shadow(0 4px 6px rgba(13,71,161,0.35))"
          }}></i>
            <span style={{
            display: "inline-block",
            position: "absolute",
            right: -2,
            top: 10,
            width: 2,
            height: 16,
            background: "#0D47A1",
            transformOrigin: "top",
            animation: "tasselSwing 1.4s ease-in-out infinite"
          }} />
          </div>
        </div>
        <div style={{
        color: "#0D47A1",
        fontWeight: 600,
        fontSize: 15
      }}>
          Loading admissions
          <span style={{
          display: "inline-block",
          animation: "dotBlink 1.4s infinite",
          animationDelay: "0s"
        }}>.</span>
          <span style={{
          display: "inline-block",
          animation: "dotBlink 1.4s infinite",
          animationDelay: "0.2s"
        }}>.</span>
          <span style={{
          display: "inline-block",
          animation: "dotBlink 1.4s infinite",
          animationDelay: "0.4s"
        }}>.</span>
        </div>
      </div>
    </div>;
  return <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
        @import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css');
        *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }
        body { background: #FFFFFF; font-family: 'Inter', sans-serif; }
        select option { background: #FFFFFF; color: #0D47A1; }
        ::-webkit-scrollbar { width: 6px; }
        ::-webkit-scrollbar-track { background: #FFFFFF; }
        ::-webkit-scrollbar-thumb { background: #0D47A1; border-radius: 6px; }
        
        @keyframes fadeUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes slideIn { from { opacity: 0; transform: scale(0.96); } to { opacity: 1; transform: scale(1); } }
        @keyframes slideDown { from { opacity: 0; transform: translateY(-10px); } to { opacity: 1; transform: translateY(0); } }
        @keyframes fadeInLeft { from { opacity: 0; transform: translateX(-20px); } to { opacity: 1; transform: translateX(0); } }
        @keyframes fadeInRight { from { opacity: 0; transform: translateX(20px); } to { opacity: 1; transform: translateX(0); } }
        @keyframes floatCircle { 0%, 100% { transform: translateY(0) scale(1); } 50% { transform: translateY(-16px) scale(1.06); } }

        .hero-circle { position: absolute; border-radius: 50%; pointer-events: none; }
        .hero-circle-1 { top: -36px; left: -36px; width: 150px; height: 150px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.32; animation: floatCircle 6s ease-in-out infinite; }
        .hero-circle-2 { top: 46px; left: 74px; width: 64px; height: 64px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.3; animation: floatCircle 5s ease-in-out infinite; animation-delay: 0.8s; }
        .hero-circle-3 { top: 110px; left: 6px; width: 40px; height: 40px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.4; animation: floatCircle 4.2s ease-in-out infinite; animation-delay: 1.6s; }
        .hero-circle-4 { bottom: -50px; right: -50px; width: 210px; height: 210px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.4; animation: floatCircle 6.5s ease-in-out infinite; animation-delay: 0.4s; }
        .hero-circle-5 { bottom: 30px; right: 130px; width: 110px; height: 110px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.35; animation: floatCircle 5.4s ease-in-out infinite; animation-delay: 1.2s; }
        .hero-circle-6 { bottom: 90px; right: 40px; width: 66px; height: 66px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.42; animation: floatCircle 4.6s ease-in-out infinite; animation-delay: 2.2s; }
        .hero-circle-7 { bottom: -70px; right: 60px; width: 250px; height: 250px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.32; animation: floatCircle 7s ease-in-out infinite; animation-delay: 0.6s; }
        .hero-circle-8 { bottom: 10px; right: 190px; width: 130px; height: 130px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.38; animation: floatCircle 5.8s ease-in-out infinite; animation-delay: 1.8s; }
        .hero-circle-9 { bottom: 130px; right: 8px; width: 80px; height: 80px; background: radial-gradient(circle at 32% 32%, #ABD2FA, #ABD2FA 70%); opacity: 0.45; animation: floatCircle 4.8s ease-in-out infinite; animation-delay: 2.8s; }
        
        .nav-card { transition: all 0.35s cubic-bezier(.22,1,.36,1); cursor: pointer; position: relative; overflow: hidden; }
        .nav-card:hover { transform: translateY(-8px) scale(1.03); box-shadow: 0 20px 50px rgba(13,71,161,0.35) !important; }
        .nav-card::after { content: ""; position: absolute; top: 0; left: -60%; width: 40%; height: 100%; background: linear-gradient(120deg, transparent, rgba(255,255,255,0.4), transparent); transform: skewX(-20deg); transition: left 0.65s ease; pointer-events: none; }
        .nav-card:hover::after { left: 130%; }
        .nav-card .icon-badge { transition: all 0.35s ease; }
        .nav-card:hover .icon-badge { transform: scale(1.14) rotate(-6deg); }
        .nav-card .watermark-icon { transition: all 0.35s ease; }
        .nav-card:hover .watermark-icon { transform: rotate(-16deg) scale(1.08); }
        
        .carousel-arrow { transition: all 0.3s ease; }
        .carousel-arrow:hover { transform: scale(1.1); background: #2196F3 !important; color: #0D47A1 !important; }
        
        .trow { transition: background 0.2s ease; }
        .trow:hover { background: #2196F3 !important; }
        .action-btn { transition: all 0.2s ease; }
        .action-btn:hover { transform: translateY(-1px); filter: brightness(0.95); }
        .doc-lbl { transition: all 0.2s ease; }
        .doc-lbl:hover { transform: translateX(2px); }
        .form-slide { animation: slideIn 0.25s ease; }
        .group-card { transition: all 0.2s ease; cursor: pointer; }
        .group-card:hover { transform: translateY(-3px); box-shadow: 0 12px 28px rgba(13,71,161,0.1) !important; }

        /* ===== SEARCH + ADMISSION VIEW TOOLBAR ===== */
        .search-toolbar {
          display: flex;
          align-items: center;
          gap: 14px;
          flex-wrap: nowrap;
        }
        .search-field-wrap {
          flex: 1 1 auto;
          min-width: 0;
        }
        .search-field-wrap input:focus {
          border-color: #2196F3 !important;
          box-shadow: 0 0 0 3px rgba(33,150,243,0.18), 0 2px 10px rgba(13,71,161,0.08) !important;
        }
        .search-clear-btn:hover { opacity: 1 !important; transform: translateY(-50%) scale(1.1); }
        .admission-view-btn { transition: all 0.2s ease; flex-shrink: 0; }
        .admission-view-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(33,150,243,0.35) !important; }

        .logout-btn { transition: all 0.2s ease; }
        .logout-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(13,71,161,0.55) !important; }
        
        /* ===== DESKTOP TABLE ===== */
        .table-header {
          display: grid;
          grid-template-columns: 2.5fr 1fr 0.8fr 0.9fr 1.1fr 100px;
          gap: 10px;
          padding: 10px 20px;
          background: #0D47A1;
        }
        .table-header > div { color: #FFFFFF !important; }
        
        .table-row {
          display: grid;
          grid-template-columns: 2.5fr 1fr 0.8fr 0.9fr 1.1fr 100px;
          gap: 10px;
          padding: 12px 20px;
          background: #FFFFFF;
          align-items: center;
        }
        
        /* ===== MOBILE OVERRIDES ===== */
        @media (max-width: 768px) {
          .hide-mobile { display: none !important; }
          .show-mobile { display: flex !important; }
          
          .table-header { display: none !important; }
          
          .table-row {
            display: grid !important;
            grid-template-columns: 1fr !important;
            gap: 6px !important;
            padding: 14px 16px !important;
            border-radius: 16px !important;
            margin-bottom: 10px !important;
            background: white !important;
            box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
            border: 1px solid #2196F3 !important;
          }
          
          .table-row > div {
            display: flex !important;
            justify-content: space-between !important;
            align-items: center !important;
            padding: 2px 0 !important;
          }
          
          .table-row > div::before {
            content: attr(data-label) !important;
            font-size: 9px !important;
            font-weight: 700 !important;
            color: #0D47A1 !important;
            text-transform: uppercase !important;
            letter-spacing: 0.5px !important;
          }
          
          .action-btns {
            display: flex !important;
            justify-content: flex-end !important;
            gap: 8px !important;
          }
          .action-btns::before {
            display: none !important;
          }
          
          .hero-section {
            margin: 12px 12px 0 !important;
            padding: 24px 16px !important;
            flex-direction: column !important;
            text-align: center !important;
          }
          .hero-section .hero-text {
            font-size: 26px !important;
          }
          .hero-image {
            flex: 0 0 180px !important;
            height: 160px !important;
            width: 100% !important;
            max-width: 100% !important;
          }
          .hero-circle-1 { width: 100px !important; height: 100px !important; top: -24px !important; left: -24px !important; }
          .hero-circle-2 { width: 44px !important; height: 44px !important; top: 30px !important; left: 50px !important; }
          .hero-circle-3 { width: 28px !important; height: 28px !important; top: 74px !important; left: 4px !important; }
          .hero-circle-4 { width: 130px !important; height: 130px !important; bottom: -30px !important; right: -30px !important; }
          .hero-circle-5 { width: 66px !important; height: 66px !important; bottom: 16px !important; right: 74px !important; }
          .hero-circle-6 { width: 38px !important; height: 38px !important; bottom: 52px !important; right: 22px !important; }
          .hero-circle-7 { width: 150px !important; height: 150px !important; bottom: -40px !important; right: 30px !important; }
          .hero-circle-8 { width: 76px !important; height: 76px !important; bottom: 8px !important; right: 100px !important; }
          .hero-circle-9 { width: 46px !important; height: 46px !important; bottom: 76px !important; right: 6px !important; }
          
          .carousel-container {
            padding: 0 8px !important;
          }
          .carousel-card {
            padding: 16px 12px !important;
            min-height: 150px !important;
          }
          .carousel-card .icon-wrap {
            width: 36px !important;
            height: 36px !important;
            font-size: 16px !important;
          }
          .carousel-card .label {
            font-size: 12px !important;
          }
          .carousel-card .proverb {
            font-size: 9px !important;
          }
          .carousel-card .watermark-icon {
            font-size: 50px !important;
          }
          .carousel-arrow {
            width: 36px !important;
            height: 36px !important;
            font-size: 14px !important;
          }

          .search-toolbar {
            flex-wrap: wrap !important;
          }
          .search-field-wrap {
            flex: 1 1 100% !important;
            width: 100% !important;
          }
          .admission-view-btn {
            flex: 1 1 100% !important;
            width: 100% !important;
            justify-content: center !important;
          }
        }

        @media (max-width: 480px) {
          .carousel-container {
            padding: 0 4px !important;
          }
          .carousel-card {
            padding: 12px 8px !important;
            min-height: 140px !important;
          }
          .carousel-card .icon-wrap {
            width: 32px !important;
            height: 32px !important;
            font-size: 14px !important;
          }
          .carousel-card .label {
            font-size: 10px !important;
          }
          .carousel-card .proverb {
            font-size: 8px !important;
          }
          .carousel-card .watermark-icon {
            font-size: 38px !important;
          }
          .carousel-arrow {
            width: 30px !important;
            height: 30px !important;
            font-size: 12px !important;
          }
        }
      `}</style>

      <div style={{
      minHeight: "100vh",
      background: "#FFFFFF"
    }}>

        {/* ═══ HEADER - Multi-Color Gradient ═══ */}
        <div style={{
        background: "linear-gradient(135deg, #0D47A1 0%, #0D47A1 50%, #0D47A1 100%)",
        padding: "14px 24px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 100,
        boxShadow: "0 4px 20px rgba(13,71,161,0.15)",
        gap: 12
      }}>
          <div style={{
          display: "flex",
          alignItems: "center",
          gap: 12
        }}>
            <div style={{
            width: 40,
            height: 40,
            borderRadius: 14,
            background: "#2196F3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 18,
            boxShadow: "0 4px 12px rgba(33,150,243,0.3)",
            flexShrink: 0
          }}>
              <i className="fas fa-user-graduate" style={{
              color: "#0D47A1"
            }}></i>
            </div>
            <div>
              <div style={{
              fontWeight: 800,
              fontSize: "clamp(14px, 2vw, 16px)",
              color: "#FFFFFF",
              letterSpacing: "-0.3px"
            }}>
                Admission Management
              </div>
              <div style={{
              fontSize: "clamp(8px, 1vw, 9px)",
              color: "#2196F3",
              letterSpacing: "0.6px",
              textTransform: "uppercase",
              fontWeight: 600
            }}>
                2025–26 · Salem
              </div>
            </div>
          </div>

          <div style={{
          display: "flex",
          alignItems: "center",
          gap: 8
        }}>
            {success && <div style={{
            background: "#2196F3",
            color: "#0D47A1",
            padding: "4px 12px",
            borderRadius: 12,
            fontSize: 10,
            fontWeight: 600,
            animation: "fadeUp 0.3s ease",
            display: "flex",
            alignItems: "center",
            gap: 4,
            boxShadow: "0 2px 8px rgba(33,150,243,0.2)"
          }}>
                <i className="fas fa-check-circle"></i>
                <span className="hide-mobile">Enquiry submitted!</span>
              </div>}

            {/* Desktop: Transfer + Logout */}
            <div className="hide-mobile" style={{
            display: "flex",
            gap: 6,
            alignItems: "center"
          }}>
              <button onClick={() => navigate("/student-transfer")} className="nav-btn" style={{
              background: "rgba(255,255,255,0.15)",
              color: "#FFFFFF",
              border: "1px solid rgba(255,255,255,0.4)",
              padding: "6px 14px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 700,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
              whiteSpace: "nowrap"
            }}>
                <i className="fas fa-arrow-right-arrow-left"></i> Transfer
              </button>
              <button onClick={() => navigate("/login")} className="nav-btn logout-btn" style={{
              background: "linear-gradient(135deg, #90CAF9 0%, #0D47A1 100%)",
              color: "#0D47A1",
              border: "none",
              padding: "6px 14px",
              borderRadius: 10,
              fontSize: 11,
              fontWeight: 700,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: 6,
              boxShadow: "0 3px 10px rgba(13,71,161,0.45)",
              whiteSpace: "nowrap"
            }}>
                <i className="fas fa-sign-out-alt"></i> Logout
              </button>
            </div>

            {/* Mobile Menu Toggle */}
            <div className="show-mobile" style={{
            display: "none",
            alignItems: "center",
            gap: 6
          }}>
              <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} style={{
              background: "rgba(255,255,255,0.15)",
              color: "#FFFFFF",
              padding: "6px 10px",
              borderRadius: 8,
              fontSize: 14,
              cursor: "pointer",
              display: "flex",
              alignItems: "center"
            }}>
                <i className={`fas ${mobileMenuOpen ? "fa-times" : "fa-bars"}`}></i>
              </button>
            </div>
          </div>
        </div>

        {/* ═══ MOBILE DROPDOWN MENU ═══ */}
        {mobileMenuOpen && <div className="mobile-menu" style={{
        background: "linear-gradient(135deg, #0D47A1 0%, #0D47A1 100%)",
        padding: "10px 16px 14px",
        display: "flex",
        flexWrap: "wrap",
        gap: 6,
        position: "sticky",
        top: "66px",
        zIndex: 99,
        boxShadow: "0 4px 16px rgba(13,71,161,0.15)"
      }}>
            {navCards.map((btn, idx) => <button key={idx} onClick={() => {
          setMobileMenuOpen(false);
          if (btn.action === "attendance") {
            setShowStaffAttendance(true);
          } else if (btn.path) {
            navigate(btn.path);
          }
        }} style={{
          background: "#2196F3",
          color: "#0D47A1",
          padding: "6px 14px",
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 6,
          boxShadow: "0 2px 4px rgba(33,150,243,0.2)",
          flex: "1 0 auto",
          justifyContent: "center",
          minWidth: "70px"
        }}>
                <i className={`fas ${btn.icon}`}></i>
                {btn.label}
              </button>)}
            <button onClick={() => {
          setMobileMenuOpen(false);
          navigate("/student-transfer");
        }} style={{
          background: "#2196F3",
          color: "#0D47A1",
          padding: "6px 14px",
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 600,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 6,
          boxShadow: "0 2px 4px rgba(33,150,243,0.2)",
          flex: "1 0 auto",
          justifyContent: "center",
          minWidth: "70px"
        }}>
              <i className="fas fa-arrow-right-arrow-left"></i> Transfer
            </button>
            <button onClick={() => {
          setMobileMenuOpen(false);
          navigate("/login");
        }} className="logout-btn" style={{
          background: "linear-gradient(135deg, #90CAF9 0%, #0D47A1 100%)",
          color: "#0D47A1",
          padding: "6px 14px",
          borderRadius: 8,
          fontSize: 11,
          fontWeight: 700,
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: 6,
          flex: "1 0 auto",
          justifyContent: "center",
          minWidth: "70px",
          boxShadow: "0 3px 10px rgba(13,71,161,0.45)"
        }}>
              <i className="fas fa-sign-out-alt"></i> Logout
            </button>
          </div>}

        {/* ═══ HERO SECTION ═══ */}
        <HeroSection />

        {/* ═══ 8 NAV CARDS - CAROUSEL (3 visible at a time) ═══ */}
        <div style={{
        padding: "24px 24px 8px"
      }}>
          <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          marginBottom: 16
        }}>
            <div style={{
            display: "flex",
            alignItems: "center",
            gap: 12
          }}>
              <div style={{
              width: 4,
              height: 24,
              background: "#2196F3",
              borderRadius: 2
            }} />
              <span style={{
              fontSize: 14,
              fontWeight: 700,
              color: "#0D47A1",
              letterSpacing: "0.5px"
            }}>
                <i className="fas fa-compass" style={{
                marginRight: 8,
                color: "#2196F3"
              }}></i>
                Quick Navigation
              </span>
              <span style={{
              fontSize: 11,
              color: "#0D47A1",
              opacity: 0.6
            }}>
                ({carouselIndex + 1} / {totalPages})
              </span>
            </div>
            <div style={{
            display: "flex",
            gap: 8
          }}>
              <button onClick={goToPrev} className="carousel-arrow" style={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              background: "#0D47A1",
              color: "#FFFFFF",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 16,
              boxShadow: "0 4px 12px rgba(13,71,161,0.2)",
              transition: "all 0.3s ease"
            }} onMouseEnter={e => {
              e.target.style.background = "#2196F3";
              e.target.style.color = "#0D47A1";
            }} onMouseLeave={e => {
              e.target.style.background = "#0D47A1";
              e.target.style.color = "#FFFFFF";
            }}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <button onClick={goToNext} className="carousel-arrow" style={{
              width: 44,
              height: 44,
              borderRadius: "50%",
              background: "#0D47A1",
              color: "#FFFFFF",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 16,
              boxShadow: "0 4px 12px rgba(13,71,161,0.2)",
              transition: "all 0.3s ease"
            }} onMouseEnter={e => {
              e.target.style.background = "#2196F3";
              e.target.style.color = "#0D47A1";
            }} onMouseLeave={e => {
              e.target.style.background = "#0D47A1";
              e.target.style.color = "#FFFFFF";
            }}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>

          <div className="carousel-container" style={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 1fr)",
          gap: 16,
          transition: "all 0.3s ease"
        }}>
            {getVisibleCards().map((card, idx) => {
            const theme = card.theme;
            return <div key={carouselIndex * cardsPerPage + idx} className="nav-card carousel-card" onClick={() => {
              if (card.action === "attendance") {
                setShowStaffAttendance(true);
              } else if (card.path) {
                navigate(card.path);
              }
            }} style={{
              background: `linear-gradient(135deg, ${theme.grad[0]} 0%, ${theme.grad[1]} 100%)`,
              borderRadius: 20,
              padding: "24px 20px",
              boxShadow: "0 10px 28px rgba(13,71,161,0.22)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              gap: 12,
              cursor: "pointer",
              minHeight: "180px",
              justifyContent: "center",
              position: "relative",
              overflow: "hidden",
              animation: idx === 0 ? "fadeInLeft 0.4s ease" : idx === 1 ? "fadeInUp 0.4s ease" : "fadeInRight 0.4s ease"
            }}>
                  {/* decorative accent shapes */}
                  <div style={{
                position: "absolute",
                bottom: -34,
                right: -34,
                width: 120,
                height: 120,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.12)",
                pointerEvents: "none"
              }} />
                  <div style={{
                position: "absolute",
                top: -18,
                left: -18,
                width: 68,
                height: 68,
                borderRadius: "50%",
                background: "rgba(255,255,255,0.08)",
                pointerEvents: "none"
              }} />

                  {/* faint watermark icon for school-themed depth */}
                  <i className={`fas ${card.icon} watermark-icon`} style={{
                position: "absolute",
                top: -8,
                right: -4,
                fontSize: 88,
                color: theme.text,
                opacity: 0.16,
                transform: "rotate(-12deg)",
                pointerEvents: "none"
              }}></i>

                  {/* unread badge, e.g. for Principal Message */}
                  {!!card.badge && <div style={{
                position: "absolute",
                top: 12,
                right: 12,
                minWidth: 22,
                height: 22,
                padding: "0 6px",
                borderRadius: 11,
                background: "#FF3B30",
                color: "#FFFFFF",
                fontSize: 11,
                fontWeight: 800,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
                zIndex: 2
              }}>
                      {card.badge > 9 ? "9+" : card.badge}
                    </div>}

                  <div className="icon-wrap icon-badge" style={{
                width: 56,
                height: 56,
                borderRadius: 16,
                background: "rgba(255,255,255,0.92)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 24,
                color: theme.grad[0],
                flexShrink: 0,
                position: "relative",
                zIndex: 1,
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)"
              }}>
                    <i className={`fas ${card.icon}`}></i>
                  </div>
                  <div className="label" style={{
                fontWeight: 800,
                fontSize: 15,
                color: theme.text,
                letterSpacing: "-0.2px",
                position: "relative",
                zIndex: 1
              }}>
                    {card.label}
                  </div>
                  {card.proverb && <div className="proverb" style={{
                fontSize: 11,
                color: theme.text,
                opacity: 0.88,
                fontStyle: "italic",
                lineHeight: 1.4,
                maxWidth: "90%",
                position: "relative",
                zIndex: 1
              }}>
                      "{card.proverb}"
                    </div>}
                </div>;
          })}
          </div>

          {/* Dot Indicators */}
          <div style={{
          display: "flex",
          justifyContent: "center",
          gap: 8,
          marginTop: 16
        }}>
            {Array.from({
            length: totalPages
          }).map((_, i) => <div key={i} onClick={() => setCarouselIndex(i)} style={{
            width: i === carouselIndex ? 28 : 8,
            height: 8,
            borderRadius: 4,
            background: i === carouselIndex ? "#2196F3" : "#90CAF9",
            cursor: "pointer",
            transition: "all 0.3s ease"
          }} />)}
          </div>
        </div>

        {/* ═══ SEARCH (LEFT, EXPANDED) + ADMISSION VIEW TOGGLE (RIGHT) ═══ */}
        <div style={{
        padding: "8px 24px 0"
      }}>
          <div className="search-toolbar">
            <div className="search-field-wrap">
              <div style={{
              position: "relative"
            }}>
                <div style={{
                position: "absolute",
                left: 4,
                top: "50%",
                transform: "translateY(-50%)",
                width: 32,
                height: 32,
                borderRadius: 10,
                background: searchFocused ? "#0D47A1" : "#E3F2FD",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.2s ease",
                pointerEvents: "none"
              }}>
                  <i className="fas fa-search" style={{
                  color: searchFocused ? "#2196F3" : "#0D47A1",
                  fontSize: 13
                }}></i>
                </div>
                <input type="text" value={searchQuery} onFocus={() => setSearchFocused(true)} onBlur={() => setSearchFocused(false)} onChange={e => {
                const v = e.target.value;
                setSearchQuery(v);
                if (v.trim() && !showAdmissionTable) setShowAdmissionTable(true);
              }} placeholder="Search by student name, class, section, parent name or phone..." style={{
                ...inputBase,
                width: "100%",
                paddingLeft: 48,
                paddingRight: searchQuery ? 40 : 16,
                paddingTop: 13,
                paddingBottom: 13,
                borderRadius: 16,
                fontSize: 13.5,
                border: "1.5px solid #90CAF9",
                background: "#E3F2FD",
                boxShadow: "0 2px 12px rgba(33,150,243,0.12)"
              }} />
                {searchQuery && <button className="search-clear-btn" onClick={() => setSearchQuery("")} style={{
                position: "absolute",
                right: 14,
                top: "50%",
                transform: "translateY(-50%)",
                background: "none",
                border: "none",
                color: "#0D47A1",
                cursor: "pointer",
                fontSize: 15,
                opacity: 0.55,
                padding: 0,
                transition: "all 0.2s ease"
              }}>
                    <i className="fas fa-times-circle"></i>
                  </button>}
              </div>
              {searchQuery.trim() && <div style={{
              fontSize: 11,
              color: "#0D47A1",
              opacity: 0.65,
              marginTop: 6,
              paddingLeft: 6,
              display: "flex",
              alignItems: "center",
              gap: 6
            }}>
                  <i className="fas fa-filter" style={{
                fontSize: 9
              }}></i>
                  {filtered.length} match{filtered.length !== 1 ? "es" : ""} found
                </div>}
            </div>
            <button className="admission-view-btn" onClick={() => setShowAdmissionTable(v => !v)} style={{
            background: showAdmissionTable ? "#0D47A1" : "#2196F3",
            color: showAdmissionTable ? "#FFFFFF" : "#0D47A1",
            border: "none",
            padding: "13px 28px",
            borderRadius: 16,
            fontSize: 13,
            fontWeight: 700,
            cursor: "pointer",
            boxShadow: "0 4px 14px rgba(13,71,161,0.15)",
            display: "flex",
            alignItems: "center",
            gap: 8,
            whiteSpace: "nowrap",
            height: "fit-content"
          }}>
              <i className={`fas ${showAdmissionTable ? "fa-eye-slash" : "fa-eye"}`}></i>
              {showAdmissionTable ? "Hide Admission View" : "Admission View"}
            </button>
          </div>
        </div>

        {/* ═══ TABLE ═══ */}
        {showAdmissionTable && <div style={{
        padding: "16px 24px 40px"
      }}>

          {/* ═══ YEAR FILTER + PRINT/DOWNLOAD BAR ═══ */}
          <div style={{
          background: "#FFFFFF",
          borderRadius: 18,
          border: "2px solid #2196F3",
          padding: "14px 18px",
          marginBottom: 14,
          display: "flex",
          alignItems: "center",
          gap: 12,
          flexWrap: "wrap"
        }}>
            <span style={{
            fontSize: 11,
            fontWeight: 700,
            color: "#0D47A1",
            textTransform: "uppercase",
            letterSpacing: "0.5px"
          }}>
              <i className="fas fa-calendar-alt" style={{
              marginRight: 6,
              color: "#2196F3"
            }}></i>
              Academic Year
            </span>
            <input type="text" value={yearInput} onChange={e => setYearInput(e.target.value)} placeholder="e.g. 2026-2027" style={{
            ...inputBase,
            width: "auto",
            minWidth: 160
          }} />
            {yearInput && !academicYearRange && <span style={{
            fontSize: 11,
            color: "#0D47A1"
          }}>Format: YYYY-YYYY (e.g. 2026-2027)</span>}
            {yearInput && <button onClick={() => setYearInput("")} style={{
            background: "#E3F2FD",
            color: "#0D47A1",
            border: "1px solid #90CAF9",
            padding: "8px 14px",
            borderRadius: 10,
            fontSize: 11,
            fontWeight: 600,
            cursor: "pointer"
          }}>
                Clear
              </button>}
            <button onClick={handlePrintDownload} style={{
            marginLeft: "auto",
            background: "#0D47A1",
            color: "#FFFFFF",
            border: "none",
            padding: "10px 18px",
            borderRadius: 12,
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            boxShadow: "0 4px 14px rgba(13,71,161,0.2)",
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
              <i className="fas fa-print"></i> Print / Download PDF
            </button>
          </div>

          <div style={{
          background: "#FFFFFF",
          borderRadius: 24,
          boxShadow: "0 2px 12px rgba(13,71,161,0.04)",
          border: "2px solid #2196F3"
        }}>
            <div style={{
            padding: "16px 20px",
            background: "#0D47A1",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            borderRadius: "24px 24px 0 0"
          }}>
              <div style={{
              fontWeight: 800,
              fontSize: 14,
              color: "#FFFFFF"
            }}>
                All Enquiries <span style={{
                fontWeight: 400,
                fontSize: 11,
                color: "#2196F3"
              }}>({filtered.length})</span>
              </div>
              <div style={{
              display: "flex",
              gap: 6,
              flexWrap: "wrap"
            }}>
                {["All", ...Object.keys(STATUS_CONFIG)].map(s => {
                const active = filterStatus === s;
                return <button key={s} onClick={() => setFilterStatus(s)} style={{
                  padding: "4px 12px",
                  borderRadius: 20,
                  fontSize: 10,
                  cursor: "pointer",
                  fontWeight: active ? 700 : 500,
                  transition: "all 0.2s",
                  background: active ? "#2196F3" : "transparent",
                  color: active ? "#0D47A1" : "#FFFFFF",
                  boxShadow: active ? "0 2px 8px rgba(33,150,243,0.2)" : "none",
                  border: active ? "none" : "1px solid rgba(255,255,255,0.2)"
                }}>
                      {s}
                    </button>;
              })}
              </div>
            </div>

            {/* ===== TABLE HEADER (Desktop Only) ===== */}
            <div className="table-header">
              {["Student / Parent", "Class", "Medium", "Date", "Status", "Actions"].map(h => <div key={h} style={{
              fontSize: 9,
              fontWeight: 700,
              color: "#FFFFFF",
              textTransform: "uppercase",
              letterSpacing: "1px"
            }}>
                  {h}
                </div>)}
            </div>

            {filtered.length === 0 && <div style={{
            padding: 48,
            textAlign: "center"
          }}>
                <i className="fas fa-inbox" style={{
              fontSize: 40,
              color: "#0D47A1",
              display: "block",
              marginBottom: 12
            }}></i>
                <div style={{
              color: "#0D47A1",
              fontSize: 13
            }}>No records found</div>
              </div>}

            {filtered.map((s, idx) => <div key={s._id} className="table-row" style={{
            background: idx % 2 === 0 ? "#FFFFFF" : "#2196F3/5",
            borderBottom: "1px solid #E3F2FD"
          }}>
                <div data-label="Student / Parent" style={{
              display: "flex",
              alignItems: "center",
              gap: 12
            }}>
                  <Avatar name={s.studentName} idx={idx} size={36} />
                  <div>
                    <div style={{
                  fontSize: 13,
                  fontWeight: 700,
                  color: "#0D47A1"
                }}>{s.studentName}</div>
                    <div style={{
                  fontSize: 10,
                  color: "#0D47A1",
                  marginTop: 2
                }}>Parent: {s.fatherName}</div>
                  </div>
                </div>
                <div data-label="Class" style={{
              fontSize: 11,
              color: "#0D47A1",
              fontWeight: 500
            }}>{s.applyingClass}-{s.section}</div>
                <div data-label="Medium" style={{
              fontSize: 11,
              color: "#0D47A1"
            }}>{s.medium || "—"}</div>
                <div data-label="Date" style={{
              fontSize: 11,
              color: "#0D47A1"
            }}>{s.enquiryDate}</div>
                <div data-label="Status"><StatusBadge status={s.status} /></div>
                <div data-label="Actions" className="action-btns" style={{
              display: "flex",
              gap: 6
            }}>
                  <button className="action-btn" onClick={() => setViewStudent(s)} style={{
                background: "#0D47A1",
                color: "#FFFFFF",
                border: "none",
                padding: "5px 10px",
                borderRadius: 8,
                fontSize: 10,
                cursor: "pointer",
                fontWeight: 700,
                boxShadow: "0 2px 6px rgba(13,71,161,0.2)"
              }}>
                    View <ArrowRight className="inline w-[1em] h-[1em] align-[-0.125em]" />
                  </button>
                  <button className="action-btn" onClick={() => setShowCredentialsModal(s)} style={{
                background: "#2196F3",
                color: "#0D47A1",
                border: "none",
                padding: "5px 8px",
                borderRadius: 8,
                fontSize: 11,
                cursor: "pointer",
                boxShadow: "0 1px 3px rgba(33,150,243,0.2)"
              }}>
                    <i className="fas fa-key"></i>
                  </button>
                </div>
              </div>)}
          </div>
        </div>}
      </div>

      {/* ═══ MODALS ═══ */}
      {viewStudent && <DetailModal student={viewStudent} onClose={() => setViewStudent(null)} onUpdateStatus={updateStatus} />}
      {showCredentialsModal && <CredentialsModal student={showCredentialsModal} onClose={() => setShowCredentialsModal(null)} onCredentialsUpdate={u => console.log('Updated:', u)} />}
      {showStaffAttendance && <StaffAttendanceModal onClose={() => setShowStaffAttendance(false)} />}

      {/* ═══ NEW ENQUIRY FORM ═══ */}
      {showForm && <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(13,71,161,0.5)",
      zIndex: 1500,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(8px)",
      padding: "20px 12px"
    }}>
          <div className="form-slide" style={{
        background: "#FFFFFF",
        borderRadius: 28,
        width: "min(850px, 100%)",
        maxHeight: "calc(100vh - 40px)",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 40px 80px rgba(0,0,0,0.1)",
        border: "2px solid #2196F3"
      }}>
            <div style={{
          background: "#0D47A1",
          padding: "20px 24px",
          borderRadius: "28px 28px 0 0",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          flexShrink: 0
        }}>
              <div>
                <div style={{
              fontWeight: 800,
              fontSize: 16,
              color: "#FFFFFF"
            }}>
                  <i className="fas fa-edit" style={{
                marginRight: 8
              }}></i> New Admission Enquiry
                </div>
                <div style={{
              fontSize: 11,
              color: "#2196F3",
              marginTop: 2
            }}>Academic Year 2025–26</div>
              </div>
              <div style={{
            display: "flex",
            alignItems: "center",
            gap: 8
          }}>
                <button onClick={() => setShowQrModal(true)} title="QR Code" style={{
              background: "rgba(255,255,255,0.2)",
              border: "none",
              color: "#FFFFFF",
              borderRadius: 10,
              width: 34,
              height: 34,
              fontSize: 15,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
                  <i className="fas fa-qrcode"></i>
                </button>
                <button onClick={() => {
              setShowForm(false);
              setErrors({});
            }} style={{
              background: "rgba(255,255,255,0.2)",
              border: "none",
              color: "#FFFFFF",
              borderRadius: 10,
              width: 34,
              height: 34,
              fontSize: 16,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
                  <i className="fas fa-times"></i>
                </button>
              </div>
            </div>

            <div style={{
          overflowY: "auto",
          flex: 1,
          padding: "24px"
        }}>
              <SecHead icon="fa-user-graduate" title="Student Details" />
              <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "0 20px"
          }}>
                <FLabel label="Student Full Name" required err={errors.studentName}>
                  <Inp value={form.studentName} onChange={setField("studentName")} placeholder="Enter student's full name" />
                </FLabel>
                <FLabel label="Date of Birth" required err={errors.dob}>
                  <Inp type="date" value={form.dob} onChange={setField("dob")} />
                </FLabel>
                <FLabel label="Gender" required err={errors.gender}>
                  <Sel value={form.gender} onChange={setField("gender")}>
                    <option value="">Select Gender</option>
                    <option>Male</option>
                    <option>Female</option>
                    <option>Other</option>
                  </Sel>
                </FLabel>
                <FLabel label="Blood Group">
                  <Sel value={form.bloodGroup} onChange={setField("bloodGroup")}>
                    <option value="">Select</option>
                    {BLOOD_GROUPS.map(b => <option key={b}>{b}</option>)}
                  </Sel>
                </FLabel>
                <FLabel label="Religion">
                  <Sel value={form.religion} onChange={setField("religion")}>
                    <option value="">Select</option>
                    {RELIGIONS.map(r => <option key={r}>{r}</option>)}
                  </Sel>
                </FLabel>
                <FLabel label="Mother Tongue">
                  <Inp value={form.motherTongue} onChange={setField("motherTongue")} placeholder="e.g. Tamil" />
                </FLabel>
                <FLabel label="Nationality">
                  <Sel value={form.nationality} onChange={setField("nationality")}>
                    {NATIONALITIES.map(n => <option key={n}>{n}</option>)}
                  </Sel>
                </FLabel>
                <FLabel label="Aadhaar Number (Student)">
                  <Inp value={form.aadhaar} onChange={setField("aadhaar")} placeholder="XXXX-XXXX-XXXX" maxLength={14} />
                </FLabel>
              </div>

              <SecHead icon="fa-book" title="Academic Details" />
              <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "0 20px"
          }}>
                <FLabel label="Applying for Class" required err={errors.applyingClass}>
                  <Sel value={form.applyingClass} onChange={setField("applyingClass")}>
                    <option value="">Select Class</option>
                    {CLASS_OPTIONS.map(c => <option key={c}>{c}</option>)}
                  </Sel>
                </FLabel>
                <FLabel label="Section" required err={errors.section}>
                  <Sel value={form.section} onChange={setField("section")}>
                    <option value="">Select Section</option>
                    {SECTIONS.map(s => <option key={s} value={s}>Section {s}</option>)}
                  </Sel>
                </FLabel>
                <FLabel label="Medium of Instruction" required err={errors.medium}>
                  <Sel value={form.medium} onChange={setField("medium")}>
                    <option value="">Select Medium</option>
                    <option>Tamil</option>
                    <option>English</option>
                  </Sel>
                </FLabel>
              </div>

              {isHighSchool && <div style={{
            background: "#2196F3/10",
            borderRadius: 18,
            padding: 16,
            marginBottom: 20,
            border: "2px solid #2196F3"
          }}>
                  <div style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#0D47A1",
              marginBottom: 12,
              textTransform: "uppercase",
              letterSpacing: "0.5px"
            }}>
                    <i className="fas fa-layer-group" style={{
                marginRight: 6
              }}></i> Group Selection — Class 11 & 12
                  </div>
                  {errors.group && <div style={{
              fontSize: 10,
              color: "#0D47A1",
              marginBottom: 10
            }}>{errors.group}</div>}
                  <div style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
              gap: 10
            }}>
                    {HS_GROUPS.map(g => {
                const selected = form.group === g.value;
                return <div key={g.value} className="group-card" onClick={() => {
                  setForm(f => ({
                    ...f,
                    group: g.value,
                    groupCategory: g.value
                  }));
                  if (errors.group) setErrors(er => ({
                    ...er,
                    group: null
                  }));
                }} style={{
                  borderRadius: 12,
                  padding: "10px 12px",
                  background: "#FFFFFF",
                  boxShadow: selected ? "0 2px 12px rgba(13,71,161,0.15)" : "0 1px 3px rgba(0,0,0,0.05)",
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  border: selected ? "2px solid #2196F3" : "1px solid #90CAF9"
                }}>
                          <div style={{
                    width: 32,
                    height: 32,
                    borderRadius: 10,
                    flexShrink: 0,
                    background: selected ? "#2196F3" : "#E3F2FD",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 14
                  }}>
                            <i className={`fas ${g.icon}`} style={{
                      color: selected ? "#0D47A1" : "#0D47A1"
                    }}></i>
                          </div>
                          <div style={{
                    flex: 1
                  }}>
                            <div style={{
                      fontSize: 11,
                      fontWeight: 700,
                      color: selected ? "#0D47A1" : "#0D47A1"
                    }}>{g.label}</div>
                            <div style={{
                      fontSize: 9,
                      color: "#0D47A1"
                    }}>{g.sub}</div>
                          </div>
                          {selected && <div style={{
                    width: 18,
                    height: 18,
                    borderRadius: "50%",
                    background: "#2196F3",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: 9,
                    color: "#0D47A1",
                    flexShrink: 0
                  }}>
                              <i className="fas fa-check"></i>
                            </div>}
                        </div>;
              })}
                  </div>
                </div>}

              <SecHead icon="fa-school" title="Previous School Details" />
              <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "0 20px"
          }}>
                <FLabel label="Previous School Name">
                  <Inp value={form.prevSchool} onChange={setField("prevSchool")} placeholder="School name" />
                </FLabel>
                <FLabel label="Previous Class Studied">
                  <Inp value={form.prevClass} onChange={setField("prevClass")} placeholder="e.g. Class 5" />
                </FLabel>
                <FLabel label="Board">
                  <Sel value={form.prevBoard} onChange={setField("prevBoard")}>
                    <option value="">Select Board</option>
                    <option>State Board</option>
                    <option>CBSE</option>
                    <option>ICSE</option>
                    <option>Matric</option>
                  </Sel>
                </FLabel>
                <FLabel label="TC Number">
                  <Inp value={form.tcNumber} onChange={setField("tcNumber")} placeholder="TC Number" />
                </FLabel>
              </div>

              <SecHead icon="fa-users" title="Parent / Guardian Details" />
              <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: "0 20px"
          }}>
                <FLabel label="Father's Name" required err={errors.fatherName}>
                  <Inp value={form.fatherName} onChange={setField("fatherName")} placeholder="Father's full name" />
                </FLabel>
                <FLabel label="Father's Occupation">
                  <Inp value={form.fatherOccupation} onChange={setField("fatherOccupation")} placeholder="Occupation" />
                </FLabel>
                <FLabel label="Father's Mobile" required err={errors.fatherMobile}>
                  <Inp value={form.fatherMobile} onChange={setField("fatherMobile")} placeholder="10-digit mobile" maxLength={10} type="tel" />
                </FLabel>
                <FLabel label="Father's Aadhaar">
                  <Inp value={form.fatherAadhaar} onChange={setField("fatherAadhaar")} placeholder="XXXX-XXXX-XXXX" maxLength={14} />
                </FLabel>
                <FLabel label="Mother's Name">
                  <Inp value={form.motherName} onChange={setField("motherName")} placeholder="Mother's full name" />
                </FLabel>
                <FLabel label="Mother's Occupation">
                  <Inp value={form.motherOccupation} onChange={setField("motherOccupation")} placeholder="Occupation" />
                </FLabel>
                <FLabel label="Mother's Mobile">
                  <Inp value={form.motherMobile} onChange={setField("motherMobile")} placeholder="10-digit mobile" maxLength={10} type="tel" />
                </FLabel>
              </div>

              <SecHead icon="fa-home" title="Address" />
              <FLabel label="Full Address">
                <textarea value={form.address} onChange={setField("address")} placeholder="Door No, Street, Area" rows={2} style={{
              ...inputBase,
              resize: "vertical"
            }} />
              </FLabel>
              <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "0 20px"
          }}>
                <FLabel label="City / Town">
                  <Inp value={form.city} onChange={setField("city")} placeholder="City" />
                </FLabel>
                <FLabel label="Pincode">
                  <Inp value={form.pincode} onChange={setField("pincode")} placeholder="6-digit pincode" maxLength={6} type="tel" />
                </FLabel>
              </div>

              <SecHead icon="fa-file-alt" title="Documents Received" />
              <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: 8
          }}>
                {DOCUMENTS.map(doc => {
              const chk = form.documents.includes(doc);
              return <label key={doc} className="doc-lbl" style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                fontSize: 11,
                color: chk ? "#FFFFFF" : "#0D47A1",
                cursor: "pointer",
                padding: "8px 12px",
                borderRadius: 10,
                background: chk ? "#0D47A1" : "#E3F2FD",
                transition: "all 0.2s",
                fontWeight: chk ? 600 : 400,
                boxShadow: chk ? "0 2px 8px rgba(13,71,161,0.2)" : "0 1px 3px rgba(0,0,0,0.05)",
                border: chk ? "none" : "1px solid #90CAF9"
              }}>
                      <input type="checkbox" checked={chk} onChange={() => toggleDoc(doc)} style={{
                  accentColor: "#2196F3",
                  width: 14,
                  height: 14,
                  flexShrink: 0
                }} />
                      {doc}
                    </label>;
            })}
              </div>

              <SecHead icon="fa-pen" title="Remarks" />
              <FLabel label="Additional Notes / Remarks">
                <textarea value={form.remarks} onChange={setField("remarks")} placeholder="Any additional remarks..." rows={2} style={{
              ...inputBase,
              resize: "vertical"
            }} />
              </FLabel>

              <div style={{
            display: "flex",
            gap: 10,
            marginTop: 24
          }}>
                <button onClick={() => {
              setShowForm(false);
              setErrors({});
            }} style={{
              flex: 1,
              background: "#E3F2FD",
              color: "#0D47A1",
              border: "1px solid #90CAF9",
              padding: 12,
              borderRadius: 14,
              fontSize: 12,
              fontWeight: 600,
              cursor: "pointer",
              boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
            }}>
                  Cancel
                </button>
                <button onClick={handleSubmit} disabled={submitting} style={{
              flex: 2,
              background: submitting ? "#0D47A1" : "#2196F3",
              color: submitting ? "#FFFFFF" : "#0D47A1",
              border: "none",
              padding: 12,
              borderRadius: 14,
              fontSize: 13,
              fontWeight: 800,
              cursor: submitting ? "not-allowed" : "pointer",
              boxShadow: submitting ? "none" : "0 4px 14px rgba(33,150,243,0.3)",
              transition: "all 0.2s"
            }}>
                  {submitting ? "Submitting..." : "Submit Enquiry"}
                </button>
              </div>
            </div>
          </div>
        </div>}

      {showQrModal && <div onClick={() => setShowQrModal(false)} style={{
      position: "fixed",
      inset: 0,
      background: "rgba(13,71,161,0.6)",
      zIndex: 2000,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(8px)",
      padding: "20px"
    }}>
          <div onClick={e => e.stopPropagation()} style={{
        background: "#FFFFFF",
        borderRadius: 24,
        padding: "26px 26px 30px",
        width: "min(360px, 100%)",
        textAlign: "center",
        boxShadow: "0 40px 80px rgba(0,0,0,0.2)",
        border: "2px solid #2196F3"
      }}>
            <div style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 18
        }}>
              <div style={{
            fontWeight: 800,
            fontSize: 15,
            color: "#0D47A1"
          }}>
                <i className="fas fa-qrcode" style={{
              marginRight: 8
            }}></i> QR Code
              </div>
              <button onClick={() => setShowQrModal(false)} style={{
            background: "#E3F2FD",
            border: "none",
            color: "#0D47A1",
            borderRadius: 8,
            width: 28,
            height: 28,
            fontSize: 13,
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div style={{
          background: "#FFFFFF",
          padding: 14,
          borderRadius: 16,
          display: "inline-block",
          border: "1px solid #90CAF9",
          boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
        }}>
              <img src={qrImageUrl} alt="Admission Form QR Code" style={{
            width: 220,
            height: 220,
            display: "block"
          }} />
            </div>

            <div style={{
          fontSize: 11.5,
          color: "#0D47A1",
          marginTop: 16,
          lineHeight: 1.7
        }}>
              Scan this QR with a phone camera to open the Admission Enquiry form.
              Fill it and hit submit — the entry will show up directly in the table below.
            </div>
            <div style={{
          fontSize: 10,
          color: "#90CAF9",
          marginTop: 10,
          wordBreak: "break-all"
        }}>
              {publicFormUrl}
            </div>

            <button onClick={handlePrintQrCode} style={{
          marginTop: 18,
          background: "linear-gradient(135deg, #2196F3 0%, #0D47A1 100%)",
          color: "#FFFFFF",
          border: "none",
          padding: "10px 20px",
          borderRadius: 10,
          fontSize: 12.5,
          fontWeight: 700,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: 8,
          boxShadow: "0 4px 12px rgba(13,71,161,0.25)"
        }}>
              <i className="fas fa-print"></i> Print QR Code
            </button>
          </div>
        </div>}
    </>;
}